/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { MasterAgencyListDto, ProviderEditDto } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { BackgroundJobExecutionDto, FileDto, Int64IdNameDto } from './shared-models';

@Injectable()
export class CommissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    resetMonth(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/Commission/ResetMonth?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetMonth(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetMonth(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processResetMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param templateId (optional)
     * @param month (optional)
     * @param year (optional)
     * @param masterAgencyId (optional)
     * @param startingDate (optional)
     * @param providerId (optional)
     * @return Success
     */
    enqueueReprocessCommissionJob(
        templateId: number | undefined,
        month: number | undefined,
        year: number | undefined,
        masterAgencyId: number | undefined,
        startingDate: moment.Moment | undefined,
        providerId: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/Commission/EnqueueReprocessCommissionJob?';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'templateId=' + encodeURIComponent('' + templateId) + '&';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'masterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (startingDate === null) throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += 'startingDate=' + encodeURIComponent(startingDate ? '' + startingDate.toJSON() : '') + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueueReprocessCommissionJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueueReprocessCommissionJob(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueueReprocessCommissionJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result400: any = null;
                    let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result400 = resultData400 !== undefined ? resultData400 : <any>null;
                    return throwException('Bad Request', status, _responseText, _headers, result400);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadCommissionFile(
        contentType: string | undefined,
        contentDisposition: string | undefined,
        headers: { [key: string]: string[] } | undefined,
        length: number | undefined,
        name: string | undefined,
        fileName: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/Commission/UploadCommissionFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (contentType === null || contentType === undefined) throw new Error("The parameter 'contentType' cannot be null.");
        else content_.append('ContentType', contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else content_.append('ContentDisposition', contentDisposition.toString());
        if (headers === null || headers === undefined) throw new Error("The parameter 'headers' cannot be null.");
        else content_.append('Headers', JSON.stringify(headers));
        if (length === null || length === undefined) throw new Error("The parameter 'length' cannot be null.");
        else content_.append('Length', length.toString());
        if (name === null || name === undefined) throw new Error("The parameter 'name' cannot be null.");
        else content_.append('Name', name.toString());
        if (fileName === null || fileName === undefined) throw new Error("The parameter 'fileName' cannot be null.");
        else content_.append('FileName', fileName.toString());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadCommissionFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadCommissionFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadCommissionFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCommissionReceivable(body: CreateOrUpdateCommissionReceivableInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateOrUpdateCommissionReceivable';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCommissionReceivable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCommissionReceivable(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCommissionReceivable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteCommissionReceivable(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/DeleteCommissionReceivable?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCommissionReceivable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCommissionReceivable(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCommissionReceivable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCommissionReceivableForEdit(id: number | undefined): Observable<GetCommissionReceivableForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionReceivableForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReceivableForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReceivableForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetCommissionReceivableForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetCommissionReceivableForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReceivableForEdit(response: HttpResponseBase): Observable<GetCommissionReceivableForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetCommissionReceivableForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetCommissionReceivableForEditOutput>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @param receivedMonth (optional)
     * @param receivedYear (optional)
     * @param applyMonth (optional)
     * @param applyYear (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionReceivableList(
        providerId: number | undefined,
        receivedMonth: number | undefined,
        receivedYear: number | undefined,
        applyMonth: number | undefined,
        applyYear: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionReceivableListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionReceivableList?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (receivedMonth === null) throw new Error("The parameter 'receivedMonth' cannot be null.");
        else if (receivedMonth !== undefined) url_ += 'ReceivedMonth=' + encodeURIComponent('' + receivedMonth) + '&';
        if (receivedYear === null) throw new Error("The parameter 'receivedYear' cannot be null.");
        else if (receivedYear !== undefined) url_ += 'ReceivedYear=' + encodeURIComponent('' + receivedYear) + '&';
        if (applyMonth === null) throw new Error("The parameter 'applyMonth' cannot be null.");
        else if (applyMonth !== undefined) url_ += 'ApplyMonth=' + encodeURIComponent('' + applyMonth) + '&';
        if (applyYear === null) throw new Error("The parameter 'applyYear' cannot be null.");
        else if (applyYear !== undefined) url_ += 'ApplyYear=' + encodeURIComponent('' + applyYear) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReceivableList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReceivableList(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReceivableListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReceivableListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReceivableList(response: HttpResponseBase): Observable<CommissionReceivableListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReceivableListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReceivableListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    checkRegisterReviewed(body: SetCommissionReceivableReviewInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CheckRegisterReviewed';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCheckRegisterReviewed(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCheckRegisterReviewed(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCheckRegisterReviewed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionReceivableFile(body: UploadCommissionFileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionReceivableFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionReceivableFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionReceivableFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionReceivableFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProviderTemplate(body: CreateOrUpdateProviderTemplateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateOrUpdateProviderTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProviderTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @param templateName (optional)
     * @param masterAgencyId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getProviderTemplateList(
        providerId: number | undefined,
        templateName: string | undefined,
        masterAgencyId: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ProviderTemplateListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetProviderTemplateList?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (templateName === null) throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined) url_ += 'TemplateName=' + encodeURIComponent('' + templateName) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderTemplateList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderTemplateList(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderTemplateListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderTemplateListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderTemplateList(response: HttpResponseBase): Observable<ProviderTemplateListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProviderTemplateListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderTemplateListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @param masterAgencyId (optional)
     * @return Success
     */
    getProviderTemplates(providerId: number | undefined, masterAgencyId: number | undefined): Observable<ProviderTemplateListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetProviderTemplates?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'masterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderTemplates(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderTemplates(<any>response_);
                        } catch (e) {
                            return <Observable<ProviderTemplateListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProviderTemplateListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderTemplates(response: HttpResponseBase): Observable<ProviderTemplateListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProviderTemplateListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProviderTemplateListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProviderTemplate(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/DeleteProviderTemplate?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProviderTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param commissionTemplateId (optional)
     * @return Success
     */
    activateProviderTemplate(commissionTemplateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/ActivateProviderTemplate?';
        if (commissionTemplateId === null) throw new Error("The parameter 'commissionTemplateId' cannot be null.");
        else if (commissionTemplateId !== undefined) url_ += 'commissionTemplateId=' + encodeURIComponent('' + commissionTemplateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processActivateProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processActivateProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processActivateProviderTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param commissionTemplateId (optional)
     * @return Success
     */
    deactivateProviderTemplate(commissionTemplateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/DeactivateProviderTemplate?';
        if (commissionTemplateId === null) throw new Error("The parameter 'commissionTemplateId' cannot be null.");
        else if (commissionTemplateId !== undefined) url_ += 'commissionTemplateId=' + encodeURIComponent('' + commissionTemplateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeactivateProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeactivateProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeactivateProviderTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProviderTemplateForEdit(id: number | undefined): Observable<GetProviderTemplateForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetProviderTemplateForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderTemplateForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderTemplateForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetProviderTemplateForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProviderTemplateForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderTemplateForEdit(response: HttpResponseBase): Observable<GetProviderTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProviderTemplateForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProviderTemplateForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProviderTemplate(body: UploadProviderTemplatFileInput | undefined): Observable<UploadProviderTemplatFileOutput> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateProviderTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<UploadProviderTemplatFileOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UploadProviderTemplatFileOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateProviderTemplate(response: HttpResponseBase): Observable<UploadProviderTemplatFileOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UploadProviderTemplatFileOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UploadProviderTemplatFileOutput>(<any>null);
    }

    /**
     * @param commissionTemplateId (optional)
     * @param providerId (optional)
     * @param masterAgencyId (optional)
     * @param templateName (optional)
     * @return Success
     */
    cloneProviderTemplate(
        commissionTemplateId: number | undefined,
        providerId: number | undefined,
        masterAgencyId: number | undefined,
        templateName: string | undefined
    ): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CloneProviderTemplate?';
        if (commissionTemplateId === null) throw new Error("The parameter 'commissionTemplateId' cannot be null.");
        else if (commissionTemplateId !== undefined) url_ += 'commissionTemplateId=' + encodeURIComponent('' + commissionTemplateId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'masterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (templateName === null) throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined) url_ += 'templateName=' + encodeURIComponent('' + templateName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCloneProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCloneProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCloneProviderTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isMCRevenue (optional)
     * @param providerId (optional)
     * @param commissionManagerId (optional)
     * @param uploaderId (optional)
     * @param showOnlyStatementsWithAlerts (optional)
     * @param showOnlyStatementsWithUploadDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCommissionCalenderList(
        month: number,
        year: number,
        isMCRevenue: boolean | undefined,
        providerId: number | undefined,
        commissionManagerId: number | undefined,
        uploaderId: number | undefined,
        showOnlyStatementsWithAlerts: boolean | undefined,
        showOnlyStatementsWithUploadDate: boolean | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionCalendarAllListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCalenderList?';
        if (month === undefined || month === null) throw new Error("The parameter 'month' must be defined and cannot be null.");
        else url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined and cannot be null.");
        else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (commissionManagerId === null) throw new Error("The parameter 'commissionManagerId' cannot be null.");
        else if (commissionManagerId !== undefined) url_ += 'CommissionManagerId=' + encodeURIComponent('' + commissionManagerId) + '&';
        if (uploaderId === null) throw new Error("The parameter 'uploaderId' cannot be null.");
        else if (uploaderId !== undefined) url_ += 'UploaderId=' + encodeURIComponent('' + uploaderId) + '&';
        if (showOnlyStatementsWithAlerts === null) throw new Error("The parameter 'showOnlyStatementsWithAlerts' cannot be null.");
        else if (showOnlyStatementsWithAlerts !== undefined)
            url_ += 'ShowOnlyStatementsWithAlerts=' + encodeURIComponent('' + showOnlyStatementsWithAlerts) + '&';
        if (showOnlyStatementsWithUploadDate === null) throw new Error("The parameter 'showOnlyStatementsWithUploadDate' cannot be null.");
        else if (showOnlyStatementsWithUploadDate !== undefined)
            url_ += 'ShowOnlyStatementsWithUploadDate=' + encodeURIComponent('' + showOnlyStatementsWithUploadDate) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCalenderList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCalenderList(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionCalendarAllListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionCalendarAllListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCalenderList(response: HttpResponseBase): Observable<CommissionCalendarAllListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionCalendarAllListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionCalendarAllListDto[]>([]);
    }

    /**
     * @param isMCRevenue (optional)
     * @param providerId (optional)
     * @param commissionManagerId (optional)
     * @param uploaderId (optional)
     * @param showOnlyStatementsWithAlerts (optional)
     * @param showOnlyStatementsWithUploadDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionCalendars(
        month: number,
        year: number,
        isMCRevenue: boolean | undefined,
        providerId: number | undefined,
        commissionManagerId: number | undefined,
        uploaderId: number | undefined,
        showOnlyStatementsWithAlerts: boolean | undefined,
        showOnlyStatementsWithUploadDate: boolean | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<PagedCommissionCalendarDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCalendars?';
        if (month === undefined || month === null) throw new Error("The parameter 'month' must be defined and cannot be null.");
        else url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined and cannot be null.");
        else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (commissionManagerId === null) throw new Error("The parameter 'commissionManagerId' cannot be null.");
        else if (commissionManagerId !== undefined) url_ += 'CommissionManagerId=' + encodeURIComponent('' + commissionManagerId) + '&';
        if (uploaderId === null) throw new Error("The parameter 'uploaderId' cannot be null.");
        else if (uploaderId !== undefined) url_ += 'UploaderId=' + encodeURIComponent('' + uploaderId) + '&';
        if (showOnlyStatementsWithAlerts === null) throw new Error("The parameter 'showOnlyStatementsWithAlerts' cannot be null.");
        else if (showOnlyStatementsWithAlerts !== undefined)
            url_ += 'ShowOnlyStatementsWithAlerts=' + encodeURIComponent('' + showOnlyStatementsWithAlerts) + '&';
        if (showOnlyStatementsWithUploadDate === null) throw new Error("The parameter 'showOnlyStatementsWithUploadDate' cannot be null.");
        else if (showOnlyStatementsWithUploadDate !== undefined)
            url_ += 'ShowOnlyStatementsWithUploadDate=' + encodeURIComponent('' + showOnlyStatementsWithUploadDate) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCalendars(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCalendars(<any>response_);
                        } catch (e) {
                            return <Observable<PagedCommissionCalendarDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PagedCommissionCalendarDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCalendars(response: HttpResponseBase): Observable<PagedCommissionCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PagedCommissionCalendarDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PagedCommissionCalendarDto>(<any>null);
    }

    /**
     * @param isMCRevenue (optional)
     * @param providerId (optional)
     * @param commissionManagerId (optional)
     * @param uploaderId (optional)
     * @param showOnlyStatementsWithAlerts (optional)
     * @param showOnlyStatementsWithUploadDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionCalendarsToExcel(
        month: number,
        year: number,
        isMCRevenue: boolean | undefined,
        providerId: number | undefined,
        commissionManagerId: number | undefined,
        uploaderId: number | undefined,
        showOnlyStatementsWithAlerts: boolean | undefined,
        showOnlyStatementsWithUploadDate: boolean | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCalendarsToExcel?';
        if (month === undefined || month === null) throw new Error("The parameter 'month' must be defined and cannot be null.");
        else url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined and cannot be null.");
        else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (commissionManagerId === null) throw new Error("The parameter 'commissionManagerId' cannot be null.");
        else if (commissionManagerId !== undefined) url_ += 'CommissionManagerId=' + encodeURIComponent('' + commissionManagerId) + '&';
        if (uploaderId === null) throw new Error("The parameter 'uploaderId' cannot be null.");
        else if (uploaderId !== undefined) url_ += 'UploaderId=' + encodeURIComponent('' + uploaderId) + '&';
        if (showOnlyStatementsWithAlerts === null) throw new Error("The parameter 'showOnlyStatementsWithAlerts' cannot be null.");
        else if (showOnlyStatementsWithAlerts !== undefined)
            url_ += 'ShowOnlyStatementsWithAlerts=' + encodeURIComponent('' + showOnlyStatementsWithAlerts) + '&';
        if (showOnlyStatementsWithUploadDate === null) throw new Error("The parameter 'showOnlyStatementsWithUploadDate' cannot be null.");
        else if (showOnlyStatementsWithUploadDate !== undefined)
            url_ += 'ShowOnlyStatementsWithUploadDate=' + encodeURIComponent('' + showOnlyStatementsWithUploadDate) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCalendarsToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCalendarsToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCalendarsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param commissionCalendarId (optional)
     * @return Success
     */
    getCommissionCalendarDetails(commissionCalendarId: number | undefined): Observable<CommissionCalendarDetailDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCalendarDetails?';
        if (commissionCalendarId === null) throw new Error("The parameter 'commissionCalendarId' cannot be null.");
        else if (commissionCalendarId !== undefined) url_ += 'commissionCalendarId=' + encodeURIComponent('' + commissionCalendarId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCalendarDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCalendarDetails(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionCalendarDetailDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionCalendarDetailDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCalendarDetails(response: HttpResponseBase): Observable<CommissionCalendarDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionCalendarDetailDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionCalendarDetailDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param commissionCalendarId (optional)
     * @param isReviewed (optional)
     * @return Success
     */
    setReviewCalendarEntry(
        month: number | undefined,
        year: number | undefined,
        commissionCalendarId: number | undefined,
        isReviewed: boolean | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/SetReviewCalendarEntry?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (commissionCalendarId === null) throw new Error("The parameter 'commissionCalendarId' cannot be null.");
        else if (commissionCalendarId !== undefined) url_ += 'commissionCalendarId=' + encodeURIComponent('' + commissionCalendarId) + '&';
        if (isReviewed === null) throw new Error("The parameter 'isReviewed' cannot be null.");
        else if (isReviewed !== undefined) url_ += 'isReviewed=' + encodeURIComponent('' + isReviewed) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSetReviewCalendarEntry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSetReviewCalendarEntry(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSetReviewCalendarEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    reviewAllCalendarEntries(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/ReviewAllCalendarEntries?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processReviewAllCalendarEntries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processReviewAllCalendarEntries(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processReviewAllCalendarEntries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getMonthStatus(month: number | undefined, year: number | undefined): Observable<MonthStatus> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetMonthStatus?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMonthStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMonthStatus(<any>response_);
                        } catch (e) {
                            return <Observable<MonthStatus>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MonthStatus>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMonthStatus(response: HttpResponseBase): Observable<MonthStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MonthStatus>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    lockAllCalendarEntries(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/LockAllCalendarEntries?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processLockAllCalendarEntries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processLockAllCalendarEntries(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processLockAllCalendarEntries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param id (optional)
     * @return Success
     */
    lockCalendarEntry(month: number | undefined, year: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/LockCalendarEntry?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processLockCalendarEntry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processLockCalendarEntry(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processLockCalendarEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    unlockAllCalendarEntries(month: number | undefined, year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UnlockAllCalendarEntries?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUnlockAllCalendarEntries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUnlockAllCalendarEntries(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUnlockAllCalendarEntries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    unlockCalendarEntry(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UnlockCalendarEntry?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUnlockCalendarEntry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUnlockCalendarEntry(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUnlockCalendarEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param note (optional)
     * @return Success
     */
    updateCommissionCalendarNotes(id: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionCalendarNotes?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (note === null) throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined) url_ += 'note=' + encodeURIComponent('' + note) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionCalendarNotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionCalendarNotes(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionCalendarNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param note (optional)
     * @return Success
     */
    updateCommissionCalendarDetailsNotes(id: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionCalendarDetailsNotes?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (note === null) throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined) url_ += 'note=' + encodeURIComponent('' + note) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionCalendarDetailsNotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionCalendarDetailsNotes(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionCalendarDetailsNotes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param date (optional)
     * @return Success
     */
    updateCommissionCalendarDetailsReceivedDate(id: number | undefined, date: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionCalendarDetailsReceivedDate?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (date === null) throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined) url_ += 'date=' + encodeURIComponent(date ? '' + date.toJSON() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionCalendarDetailsReceivedDate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionCalendarDetailsReceivedDate(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionCalendarDetailsReceivedDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isMCRevenue (optional)
     * @param providerId (optional)
     * @param commissionManagerId (optional)
     * @param uploaderId (optional)
     * @param showOnlyStatementsWithAlerts (optional)
     * @param showOnlyStatementsWithUploadDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCommissionCalenderListToExcel(
        month: number,
        year: number,
        isMCRevenue: boolean | undefined,
        providerId: number | undefined,
        commissionManagerId: number | undefined,
        uploaderId: number | undefined,
        showOnlyStatementsWithAlerts: boolean | undefined,
        showOnlyStatementsWithUploadDate: boolean | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCalenderListToExcel?';
        if (month === undefined || month === null) throw new Error("The parameter 'month' must be defined and cannot be null.");
        else url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined and cannot be null.");
        else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (commissionManagerId === null) throw new Error("The parameter 'commissionManagerId' cannot be null.");
        else if (commissionManagerId !== undefined) url_ += 'CommissionManagerId=' + encodeURIComponent('' + commissionManagerId) + '&';
        if (uploaderId === null) throw new Error("The parameter 'uploaderId' cannot be null.");
        else if (uploaderId !== undefined) url_ += 'UploaderId=' + encodeURIComponent('' + uploaderId) + '&';
        if (showOnlyStatementsWithAlerts === null) throw new Error("The parameter 'showOnlyStatementsWithAlerts' cannot be null.");
        else if (showOnlyStatementsWithAlerts !== undefined)
            url_ += 'ShowOnlyStatementsWithAlerts=' + encodeURIComponent('' + showOnlyStatementsWithAlerts) + '&';
        if (showOnlyStatementsWithUploadDate === null) throw new Error("The parameter 'showOnlyStatementsWithUploadDate' cannot be null.");
        else if (showOnlyStatementsWithUploadDate !== undefined)
            url_ += 'ShowOnlyStatementsWithUploadDate=' + encodeURIComponent('' + showOnlyStatementsWithUploadDate) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCalenderListToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCalenderListToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCalenderListToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCalendarNote(body: GetCalendarNoteInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCalendarNote';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCalendarNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCalendarNote(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCalendarNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    refreshCalendar(body: GetCommissionCalendarInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/RefreshCalendar';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRefreshCalendar(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRefreshCalendar(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processRefreshCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    openMonthCalenderList(body: GetCommissionCalendarInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/OpenMonthCalenderList';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processOpenMonthCalenderList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processOpenMonthCalenderList(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processOpenMonthCalenderList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    closeMonthCalendar(body: GetCommissionCalendarInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CloseMonthCalendar';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCloseMonthCalendar(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCloseMonthCalendar(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCloseMonthCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionCalendar(body: UpdateCommissionCalendarInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionCalendar';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionCalendar(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionCalendar(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionReviewFile(body: UpdateCommissionReviewFileInput | undefined): Observable<CommissionProviderImportDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionReviewFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionReviewFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionReviewFile(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionProviderImportDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionProviderImportDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionReviewFile(response: HttpResponseBase): Observable<CommissionProviderImportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionProviderImportDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionProviderImportDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetCommissionReviewFile(body: ResetCommissionReviewFileInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Commission/ResetCommissionReviewFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetCommissionReviewFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetCommissionReviewFile(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processResetCommissionReviewFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    processCommissionReview(body: UploadProviderFileInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Commission/ProcessCommissionReview';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processProcessCommissionReview(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processProcessCommissionReview(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processProcessCommissionReview(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    enqueueCommissionReviewProcessJob(body: UploadProviderFileInput | undefined): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/EnqueueCommissionReviewProcessJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueueCommissionReviewProcessJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueueCommissionReviewProcessJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueueCommissionReviewProcessJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    existsAPendingJob(body: UploadProviderFileInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Commission/ExistsAPendingJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExistsAPendingJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExistsAPendingJob(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processExistsAPendingJob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param commissionWorkbookDetailId (optional)
     * @return Success
     */
    deleteCommissionHold(
        month: number | undefined,
        year: number | undefined,
        commissionWorkbookDetailId: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/DeleteCommissionHold?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (commissionWorkbookDetailId === null) throw new Error("The parameter 'commissionWorkbookDetailId' cannot be null.");
        else if (commissionWorkbookDetailId !== undefined)
            url_ += 'commissionWorkbookDetailId=' + encodeURIComponent('' + commissionWorkbookDetailId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCommissionHold(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCommissionHold(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCommissionHold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createCommissionHold(body: CreateCommissionHoldDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateCommissionHold';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateCommissionHold(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateCommissionHold(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateCommissionHold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param templateId (optional)
     * @param partnerId (optional)
     * @param billingAccountNumber (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionProviderImportErrors(
        month: number | undefined,
        year: number | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        templateId: number | undefined,
        partnerId: number | undefined,
        billingAccountNumber: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionProviderImportSummaryDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionProviderImportErrors?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionProviderImportErrors(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionProviderImportErrors(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionProviderImportSummaryDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionProviderImportSummaryDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionProviderImportErrors(
        response: HttpResponseBase
    ): Observable<CommissionProviderImportSummaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionProviderImportSummaryDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionProviderImportSummaryDtoPagedResultDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param templateId (optional)
     * @param partnerId (optional)
     * @param billingAccountNumber (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getProviderImportErrorListToExcel(
        month: number | undefined,
        year: number | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        templateId: number | undefined,
        partnerId: number | undefined,
        billingAccountNumber: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetProviderImportErrorListToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderImportErrorListToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderImportErrorListToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderImportErrorListToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param templateId (optional)
     * @param partnerId (optional)
     * @param billingAccountNumber (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCommissionReviews(
        month: number | undefined,
        year: number | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        templateId: number | undefined,
        partnerId: number | undefined,
        billingAccountNumber: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionReviewDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionReviews?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReviews(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReviews(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReviews(response: HttpResponseBase): Observable<CommissionReviewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReviewDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewDtoPagedResultDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param templateId (optional)
     * @param partnerId (optional)
     * @param billingAccountNumber (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getCommissionProvidersToExcel(
        month: number | undefined,
        year: number | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        templateId: number | undefined,
        partnerId: number | undefined,
        billingAccountNumber: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionProvidersToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionProvidersToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionProvidersToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionProvidersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCommissionTrackingListById(id: number | undefined): Observable<CommissionTrackingDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionTrackingListById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionTrackingListById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionTrackingListById(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionTrackingDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionTrackingDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionTrackingListById(response: HttpResponseBase): Observable<CommissionTrackingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionTrackingDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionTrackingDto[]>([]);
    }

    /**
     * @param hasRate (optional)
     * @return Success
     */
    getCommissionTrackingList(hasRate: boolean | undefined): Observable<CommissionTrackingListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionTrackingList?';
        if (hasRate === null) throw new Error("The parameter 'hasRate' cannot be null.");
        else if (hasRate !== undefined) url_ += 'hasRate=' + encodeURIComponent('' + hasRate) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionTrackingList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionTrackingList(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionTrackingListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionTrackingListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionTrackingList(response: HttpResponseBase): Observable<CommissionTrackingListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionTrackingListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionTrackingListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrDeleteCommissionTracking(body: CreateDeleteCommissionTrackingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateOrDeleteCommissionTracking';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrDeleteCommissionTracking(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrDeleteCommissionTracking(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrDeleteCommissionTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     * @deprecated
     */
    getCommissionSummary(partnerId: number | undefined): Observable<any[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionSummary?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionSummary(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionSummary(<any>response_);
                        } catch (e) {
                            return <Observable<any[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<any[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionSummary(response: HttpResponseBase): Observable<any[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<any[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @return Success
     */
    getReportCommissionDetailBAN(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        partnerId: number | undefined
    ): Observable<ReportCommissionDetailBanDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionDetailBAN?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionDetailBAN(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionDetailBAN(<any>response_);
                        } catch (e) {
                            return <Observable<ReportCommissionDetailBanDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ReportCommissionDetailBanDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionDetailBAN(response: HttpResponseBase): Observable<ReportCommissionDetailBanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ReportCommissionDetailBanDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ReportCommissionDetailBanDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param customerName (optional)
     * @param commissionStatus (optional)
     * @param selectedMaster (optional)
     * @param customerId (optional)
     * @return Success
     */
    getReportCommissionDetail(
        month: number | undefined,
        year: number | undefined,
        providerId: string | undefined,
        partnerId: string | undefined,
        customerName: string | undefined,
        commissionStatus: string | undefined,
        selectedMaster: number | undefined,
        customerId: number | undefined
    ): Observable<ReportCommissionDetailDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionDetail?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'customerName=' + encodeURIComponent('' + customerName) + '&';
        if (commissionStatus === null) throw new Error("The parameter 'commissionStatus' cannot be null.");
        else if (commissionStatus !== undefined) url_ += 'commissionStatus=' + encodeURIComponent('' + commissionStatus) + '&';
        if (selectedMaster === null) throw new Error("The parameter 'selectedMaster' cannot be null.");
        else if (selectedMaster !== undefined) url_ += 'SelectedMaster=' + encodeURIComponent('' + selectedMaster) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'customerId=' + encodeURIComponent('' + customerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionDetail(<any>response_);
                        } catch (e) {
                            return <Observable<ReportCommissionDetailDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ReportCommissionDetailDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionDetail(response: HttpResponseBase): Observable<ReportCommissionDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ReportCommissionDetailDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ReportCommissionDetailDto[]>([]);
    }

    /**
     * @param fromMonth (optional)
     * @param fromYear (optional)
     * @param toMonth (optional)
     * @param toYear (optional)
     * @param providerId (optional)
     * @return Success
     */
    getComnmissioPMSPMDetail(
        fromMonth: number | undefined,
        fromYear: number | undefined,
        toMonth: number | undefined,
        toYear: number | undefined,
        providerId: number | undefined
    ): Observable<OutputPMSPMDetail[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetComnmissioPMSPMDetail?';
        if (fromMonth === null) throw new Error("The parameter 'fromMonth' cannot be null.");
        else if (fromMonth !== undefined) url_ += 'FromMonth=' + encodeURIComponent('' + fromMonth) + '&';
        if (fromYear === null) throw new Error("The parameter 'fromYear' cannot be null.");
        else if (fromYear !== undefined) url_ += 'FromYear=' + encodeURIComponent('' + fromYear) + '&';
        if (toMonth === null) throw new Error("The parameter 'toMonth' cannot be null.");
        else if (toMonth !== undefined) url_ += 'ToMonth=' + encodeURIComponent('' + toMonth) + '&';
        if (toYear === null) throw new Error("The parameter 'toYear' cannot be null.");
        else if (toYear !== undefined) url_ += 'ToYear=' + encodeURIComponent('' + toYear) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetComnmissioPMSPMDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetComnmissioPMSPMDetail(<any>response_);
                        } catch (e) {
                            return <Observable<OutputPMSPMDetail[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputPMSPMDetail[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetComnmissioPMSPMDetail(response: HttpResponseBase): Observable<OutputPMSPMDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputPMSPMDetail.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputPMSPMDetail[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getAccountingPartnerFirstCommission(month: number | undefined, year: number | undefined): Observable<PartnerFirstCommissionOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingPartnerFirstCommission?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingPartnerFirstCommission(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingPartnerFirstCommission(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerFirstCommissionOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerFirstCommissionOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingPartnerFirstCommission(response: HttpResponseBase): Observable<PartnerFirstCommissionOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerFirstCommissionOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerFirstCommissionOutput[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param acquisitionId (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    getAccountingUploadStatus(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        acquisitionId: number | undefined,
        isMCRevenue: boolean | undefined
    ): Observable<UploadStatusOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingUploadStatus?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'StartMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'StartYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'EndMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'EndYear=' + encodeURIComponent('' + endYear) + '&';
        if (acquisitionId === null) throw new Error("The parameter 'acquisitionId' cannot be null.");
        else if (acquisitionId !== undefined) url_ += 'AcquisitionId=' + encodeURIComponent('' + acquisitionId) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingUploadStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingUploadStatus(<any>response_);
                        } catch (e) {
                            return <Observable<UploadStatusOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UploadStatusOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingUploadStatus(response: HttpResponseBase): Observable<UploadStatusOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UploadStatusOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UploadStatusOutput[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAccountingARInvoice(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<OutputAccountinARInvoice[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingARInvoice?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingARInvoice(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingARInvoice(<any>response_);
                        } catch (e) {
                            return <Observable<OutputAccountinARInvoice[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputAccountinARInvoice[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingARInvoice(response: HttpResponseBase): Observable<OutputAccountinARInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputAccountinARInvoice.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputAccountinARInvoice[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAccountingAPVoucher(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<OutputAccountingAPVoucher[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingAPVoucher?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingAPVoucher(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingAPVoucher(<any>response_);
                        } catch (e) {
                            return <Observable<OutputAccountingAPVoucher[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputAccountingAPVoucher[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingAPVoucher(response: HttpResponseBase): Observable<OutputAccountingAPVoucher[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputAccountingAPVoucher.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputAccountingAPVoucher[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getRevenueTeamReport(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<OutputRevenueTeamReport[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetRevenueTeamReport?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRevenueTeamReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRevenueTeamReport(<any>response_);
                        } catch (e) {
                            return <Observable<OutputRevenueTeamReport[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputRevenueTeamReport[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRevenueTeamReport(response: HttpResponseBase): Observable<OutputRevenueTeamReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputRevenueTeamReport.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputRevenueTeamReport[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getCommissionSegmentationReport(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<OutputCommissionSegmentationReport[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionSegmentationReport?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionSegmentationReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionSegmentationReport(<any>response_);
                        } catch (e) {
                            return <Observable<OutputCommissionSegmentationReport[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputCommissionSegmentationReport[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionSegmentationReport(response: HttpResponseBase): Observable<OutputCommissionSegmentationReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputCommissionSegmentationReport.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputCommissionSegmentationReport[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAccountingQuickbooks(
        month: number | undefined,
        year: number | undefined,
        partnerId: number | undefined,
        providerId: number | undefined
    ): Observable<OuptutAccountingQuickbooks[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingQuickbooks?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingQuickbooks(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingQuickbooks(<any>response_);
                        } catch (e) {
                            return <Observable<OuptutAccountingQuickbooks[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OuptutAccountingQuickbooks[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingQuickbooks(response: HttpResponseBase): Observable<OuptutAccountingQuickbooks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OuptutAccountingQuickbooks.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OuptutAccountingQuickbooks[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param commissionStatus (optional)
     * @param isMcRevenue (optional)
     * @param tenant (optional)
     * @param userId (optional)
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getPartnerCommissionSummary(
        partnerId: number | undefined,
        commissionStatus: string | undefined,
        isMcRevenue: boolean | undefined,
        tenant: number | undefined,
        userId: number | undefined,
        month: number | undefined,
        year: number | undefined
    ): Observable<PartnerCommissionSummaryDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetPartnerCommissionSummary?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (commissionStatus === null) throw new Error("The parameter 'commissionStatus' cannot be null.");
        else if (commissionStatus !== undefined) url_ += 'CommissionStatus=' + encodeURIComponent('' + commissionStatus) + '&';
        if (isMcRevenue === null) throw new Error("The parameter 'isMcRevenue' cannot be null.");
        else if (isMcRevenue !== undefined) url_ += 'IsMcRevenue=' + encodeURIComponent('' + isMcRevenue) + '&';
        if (tenant === null) throw new Error("The parameter 'tenant' cannot be null.");
        else if (tenant !== undefined) url_ += 'Tenant=' + encodeURIComponent('' + tenant) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerCommissionSummary(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerCommissionSummary(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerCommissionSummaryDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerCommissionSummaryDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerCommissionSummary(response: HttpResponseBase): Observable<PartnerCommissionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerCommissionSummaryDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerCommissionSummaryDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param commissionStatus (optional)
     * @param isMcRevenue (optional)
     * @param tenant (optional)
     * @param userId (optional)
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getPartnerCommissionSummaryToExcel(
        partnerId: number | undefined,
        commissionStatus: string | undefined,
        isMcRevenue: boolean | undefined,
        tenant: number | undefined,
        userId: number | undefined,
        month: number | undefined,
        year: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetPartnerCommissionSummaryToExcel?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (commissionStatus === null) throw new Error("The parameter 'commissionStatus' cannot be null.");
        else if (commissionStatus !== undefined) url_ += 'CommissionStatus=' + encodeURIComponent('' + commissionStatus) + '&';
        if (isMcRevenue === null) throw new Error("The parameter 'isMcRevenue' cannot be null.");
        else if (isMcRevenue !== undefined) url_ += 'IsMcRevenue=' + encodeURIComponent('' + isMcRevenue) + '&';
        if (tenant === null) throw new Error("The parameter 'tenant' cannot be null.");
        else if (tenant !== undefined) url_ += 'Tenant=' + encodeURIComponent('' + tenant) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerCommissionSummaryToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerCommissionSummaryToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerCommissionSummaryToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param acquisitionId (optional)
     * @return Success
     */
    getCommissionCheckRegisterReport(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        partnerId: number | undefined,
        acquisitionId: number | undefined
    ): Observable<OutputCommissionCheck[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCheckRegisterReport?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (acquisitionId === null) throw new Error("The parameter 'acquisitionId' cannot be null.");
        else if (acquisitionId !== undefined) url_ += 'AcquisitionId=' + encodeURIComponent('' + acquisitionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCheckRegisterReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCheckRegisterReport(<any>response_);
                        } catch (e) {
                            return <Observable<OutputCommissionCheck[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputCommissionCheck[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCheckRegisterReport(response: HttpResponseBase): Observable<OutputCommissionCheck[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputCommissionCheck.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputCommissionCheck[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getCommissionHistoryByPartnerToExcel(partnerId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionHistoryByPartnerToExcel?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionHistoryByPartnerToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionHistoryByPartnerToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionHistoryByPartnerToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getCommissionHistoryByPartnerReport(partnerId: number | undefined): Observable<ReportPartnerCommissionHistory[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionHistoryByPartnerReport?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionHistoryByPartnerReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionHistoryByPartnerReport(<any>response_);
                        } catch (e) {
                            return <Observable<ReportPartnerCommissionHistory[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ReportPartnerCommissionHistory[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionHistoryByPartnerReport(response: HttpResponseBase): Observable<ReportPartnerCommissionHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ReportPartnerCommissionHistory.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ReportPartnerCommissionHistory[]>([]);
    }

    /**
     * @param providerIds (optional)
     * @return Success
     */
    getCommissionDueReport(providerIds: string | undefined): Observable<CommissionDueOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionDueReport?';
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined) url_ += 'ProviderIds=' + encodeURIComponent('' + providerIds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionDueReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionDueReport(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionDueOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionDueOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionDueReport(response: HttpResponseBase): Observable<CommissionDueOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionDueOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionDueOutput[]>([]);
    }

    /**
     * @param providerIds (optional)
     * @return Success
     */
    getCommissionDueReportToExcel(providerIds: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionDueReportToExcel?';
        if (providerIds === null) throw new Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined) url_ += 'ProviderIds=' + encodeURIComponent('' + providerIds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionDueReportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionDueReportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionDueReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param masterAgencyId (optional)
     * @param templateId (optional)
     * @return Success
     * @deprecated
     */
    getCommissionTotals(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        masterAgencyId: number | undefined,
        templateId: number | undefined
    ): Observable<CommissionTotalPreviewOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionTotals?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (templateId === null) throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined) url_ += 'TemplateId=' + encodeURIComponent('' + templateId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionTotals(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionTotals(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionTotalPreviewOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionTotalPreviewOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionTotals(response: HttpResponseBase): Observable<CommissionTotalPreviewOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionTotalPreviewOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionTotalPreviewOutput[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    getCommissionNew(
        month: number | undefined,
        year: number | undefined,
        partnerId: number | undefined,
        providerId: number | undefined,
        isMCRevenue: boolean | undefined
    ): Observable<OutputCommissionLostNew[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionNew?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionNew(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionNew(<any>response_);
                        } catch (e) {
                            return <Observable<OutputCommissionLostNew[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputCommissionLostNew[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionNew(response: HttpResponseBase): Observable<OutputCommissionLostNew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputCommissionLostNew.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputCommissionLostNew[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    getCommissionLost(
        month: number | undefined,
        year: number | undefined,
        partnerId: number | undefined,
        providerId: number | undefined,
        isMCRevenue: boolean | undefined
    ): Observable<OutputCommissionLostNew[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionLost?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionLost(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionLost(<any>response_);
                        } catch (e) {
                            return <Observable<OutputCommissionLostNew[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputCommissionLostNew[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionLost(response: HttpResponseBase): Observable<OutputCommissionLostNew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputCommissionLostNew.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputCommissionLostNew[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getCommissionPMSPMDetailToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionPMSPMDetailToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionPMSPMDetailToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionPMSPMDetailToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionPMSPMDetailToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAccountingAPVoucherToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingAPVoucherToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingAPVoucherToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingAPVoucherToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingAPVoucherToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getRevenueTeamReportToExcel(month: number | undefined, year: number | undefined, providerId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetRevenueTeamReportToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRevenueTeamReportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRevenueTeamReportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRevenueTeamReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getCommissionSegmentationReportToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionSegmentationReportToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionSegmentationReportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionSegmentationReportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionSegmentationReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param acquisitionId (optional)
     * @param isMCRevenue (optional)
     * @return Success
     */
    getAccountingUploadStatusToExcel(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        acquisitionId: number | undefined,
        isMCRevenue: boolean | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingUploadStatusToExcel?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'StartMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'StartYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'EndMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'EndYear=' + encodeURIComponent('' + endYear) + '&';
        if (acquisitionId === null) throw new Error("The parameter 'acquisitionId' cannot be null.");
        else if (acquisitionId !== undefined) url_ += 'AcquisitionId=' + encodeURIComponent('' + acquisitionId) + '&';
        if (isMCRevenue === null) throw new Error("The parameter 'isMCRevenue' cannot be null.");
        else if (isMCRevenue !== undefined) url_ += 'IsMCRevenue=' + encodeURIComponent('' + isMCRevenue) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingUploadStatusToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingUploadStatusToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingUploadStatusToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getAccountingPartnerFirstCommissionToExcel(month: number | undefined, year: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingPartnerFirstCommissionToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingPartnerFirstCommissionToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingPartnerFirstCommissionToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingPartnerFirstCommissionToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param acquisitionId (optional)
     * @return Success
     */
    getCommissionCheckRegisterReportToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        partnerId: number | undefined,
        acquisitionId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionCheckRegisterReportToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (acquisitionId === null) throw new Error("The parameter 'acquisitionId' cannot be null.");
        else if (acquisitionId !== undefined) url_ += 'AcquisitionId=' + encodeURIComponent('' + acquisitionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionCheckRegisterReportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionCheckRegisterReportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionCheckRegisterReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAccountingARInvoiceToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAccountingARInvoiceToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAccountingARInvoiceToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAccountingARInvoiceToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAccountingARInvoiceToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createUpdateCommisionAdjustment(body: CommissionAdjustmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateUpdateCommisionAdjustment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateUpdateCommisionAdjustment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateUpdateCommisionAdjustment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateUpdateCommisionAdjustment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getCommissionReviewForEdit(input: number | undefined): Observable<CommissionAdjustmentDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionReviewForEdit?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReviewForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReviewForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionAdjustmentDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionAdjustmentDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReviewForEdit(response: HttpResponseBase): Observable<CommissionAdjustmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionAdjustmentDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionAdjustmentDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    deleteCommisionAdjustment(input: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/DeleteCommisionAdjustment?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCommisionAdjustment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCommisionAdjustment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCommisionAdjustment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param paramPartnerList (optional)
     * @param paramProviderList (optional)
     * @param paramSPMList (optional)
     * @param paramIoList (optional)
     * @return Success
     */
    getReportDetailsBilling(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        paramPartnerList: string | undefined,
        paramProviderList: string | undefined,
        paramSPMList: string | undefined,
        paramIoList: string | undefined
    ): Observable<OutputReportDetailsBilling[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportDetailsBilling?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (paramPartnerList === null) throw new Error("The parameter 'paramPartnerList' cannot be null.");
        else if (paramPartnerList !== undefined) url_ += 'paramPartnerList=' + encodeURIComponent('' + paramPartnerList) + '&';
        if (paramProviderList === null) throw new Error("The parameter 'paramProviderList' cannot be null.");
        else if (paramProviderList !== undefined) url_ += 'paramProviderList=' + encodeURIComponent('' + paramProviderList) + '&';
        if (paramSPMList === null) throw new Error("The parameter 'paramSPMList' cannot be null.");
        else if (paramSPMList !== undefined) url_ += 'paramSPMList=' + encodeURIComponent('' + paramSPMList) + '&';
        if (paramIoList === null) throw new Error("The parameter 'paramIoList' cannot be null.");
        else if (paramIoList !== undefined) url_ += 'paramIoList=' + encodeURIComponent('' + paramIoList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportDetailsBilling(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportDetailsBilling(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportDetailsBilling[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportDetailsBilling[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportDetailsBilling(response: HttpResponseBase): Observable<OutputReportDetailsBilling[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportDetailsBilling.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportDetailsBilling[]>([]);
    }

    /**
     * @param providerInput (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @return Success
     */
    getReportExecSummProviderCommissions(
        providerInput: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined
    ): Observable<OutputReportExecSummProviderCommissions[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportExecSummProviderCommissions?';
        if (providerInput === null) throw new Error("The parameter 'providerInput' cannot be null.");
        else if (providerInput !== undefined) url_ += 'providerInput=' + encodeURIComponent('' + providerInput) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummProviderCommissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummProviderCommissions(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummProviderCommissions[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummProviderCommissions[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummProviderCommissions(
        response: HttpResponseBase
    ): Observable<OutputReportExecSummProviderCommissions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummProviderCommissions.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummProviderCommissions[]>([]);
    }

    /**
     * @param partnerInput (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @return Success
     */
    getReportExecSummPartnerCommissions(
        partnerInput: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined
    ): Observable<OutputReportExecSummPartnerCommissions[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportExecSummPartnerCommissions?';
        if (partnerInput === null) throw new Error("The parameter 'partnerInput' cannot be null.");
        else if (partnerInput !== undefined) url_ += 'partnerInput=' + encodeURIComponent('' + partnerInput) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummPartnerCommissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummPartnerCommissions(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummPartnerCommissions[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummPartnerCommissions[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummPartnerCommissions(response: HttpResponseBase): Observable<OutputReportExecSummPartnerCommissions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummPartnerCommissions.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummPartnerCommissions[]>([]);
    }

    /**
     * @param providerInput (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @return Success
     */
    getReportExecSummProviderBilling(
        providerInput: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined
    ): Observable<OutputReportExecSummProviderBilling[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportExecSummProviderBilling?';
        if (providerInput === null) throw new Error("The parameter 'providerInput' cannot be null.");
        else if (providerInput !== undefined) url_ += 'providerInput=' + encodeURIComponent('' + providerInput) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummProviderBilling(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummProviderBilling(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummProviderBilling[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummProviderBilling[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummProviderBilling(response: HttpResponseBase): Observable<OutputReportExecSummProviderBilling[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummProviderBilling.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummProviderBilling[]>([]);
    }

    /**
     * @param partnerInput (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @return Success
     */
    getReportExecSummPartnerBilling(
        partnerInput: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined
    ): Observable<OutputReportExecSummPartnerBilling[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportExecSummPartnerBilling?';
        if (partnerInput === null) throw new Error("The parameter 'partnerInput' cannot be null.");
        else if (partnerInput !== undefined) url_ += 'partnerInput=' + encodeURIComponent('' + partnerInput) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummPartnerBilling(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummPartnerBilling(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummPartnerBilling[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummPartnerBilling[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummPartnerBilling(response: HttpResponseBase): Observable<OutputReportExecSummPartnerBilling[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummPartnerBilling.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummPartnerBilling[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param searchType (optional)
     * @param paramPartnerList (optional)
     * @param paramProviderList (optional)
     * @param paramSPMList (optional)
     * @param paramIoList (optional)
     * @return Success
     */
    getReportTrendingBilling(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        searchType: string | undefined,
        paramPartnerList: string | undefined,
        paramProviderList: string | undefined,
        paramSPMList: string | undefined,
        paramIoList: string | undefined
    ): Observable<OutputReportTrendingBilling[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportTrendingBilling?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (searchType === null) throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined) url_ += 'searchType=' + encodeURIComponent('' + searchType) + '&';
        if (paramPartnerList === null) throw new Error("The parameter 'paramPartnerList' cannot be null.");
        else if (paramPartnerList !== undefined) url_ += 'paramPartnerList=' + encodeURIComponent('' + paramPartnerList) + '&';
        if (paramProviderList === null) throw new Error("The parameter 'paramProviderList' cannot be null.");
        else if (paramProviderList !== undefined) url_ += 'paramProviderList=' + encodeURIComponent('' + paramProviderList) + '&';
        if (paramSPMList === null) throw new Error("The parameter 'paramSPMList' cannot be null.");
        else if (paramSPMList !== undefined) url_ += 'paramSPMList=' + encodeURIComponent('' + paramSPMList) + '&';
        if (paramIoList === null) throw new Error("The parameter 'paramIoList' cannot be null.");
        else if (paramIoList !== undefined) url_ += 'paramIoList=' + encodeURIComponent('' + paramIoList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportTrendingBilling(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportTrendingBilling(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportTrendingBilling[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportTrendingBilling[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportTrendingBilling(response: HttpResponseBase): Observable<OutputReportTrendingBilling[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportTrendingBilling.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportTrendingBilling[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCommissionReviewOnHold(body: UpdateCommissionOnHoldInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionReviewOnHold';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionReviewOnHold(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionReviewOnHold(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionReviewOnHold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCommissionHoldList(): Observable<CommissionWorkbookListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionHoldList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionHoldList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionHoldList(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionWorkbookListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionWorkbookListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionHoldList(response: HttpResponseBase): Observable<CommissionWorkbookListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionWorkbookListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionWorkbookListDto[]>([]);
    }

    /**
     * @param commissionWorkBookId (optional)
     * @param masterAgency (optional)
     * @return Success
     */
    updateCommissionReviewOnRelease(commissionWorkBookId: number | undefined, masterAgency: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionReviewOnRelease?';
        if (commissionWorkBookId === null) throw new Error("The parameter 'commissionWorkBookId' cannot be null.");
        else if (commissionWorkBookId !== undefined) url_ += 'commissionWorkBookId=' + encodeURIComponent('' + commissionWorkBookId) + '&';
        if (masterAgency === null) throw new Error("The parameter 'masterAgency' cannot be null.");
        else if (masterAgency !== undefined) url_ += 'masterAgency=' + encodeURIComponent('' + masterAgency) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionReviewOnRelease(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionReviewOnRelease(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionReviewOnRelease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getCommissionAmountDashboard(partnerId: number | undefined, spmId: number | undefined): Observable<CommissionAmountDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionAmountDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionAmountDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionAmountDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionAmountDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionAmountDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionAmountDashboard(response: HttpResponseBase): Observable<CommissionAmountDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionAmountDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionAmountDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getTop6CustomersByCommissionAmountDashboard(
        partnerId: number | undefined,
        spmId: number | undefined
    ): Observable<Top6CustomersByCommissionAmountDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetTop6CustomersByCommissionAmountDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTop6CustomersByCommissionAmountDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTop6CustomersByCommissionAmountDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<Top6CustomersByCommissionAmountDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Top6CustomersByCommissionAmountDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTop6CustomersByCommissionAmountDashboard(
        response: HttpResponseBase
    ): Observable<Top6CustomersByCommissionAmountDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Top6CustomersByCommissionAmountDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Top6CustomersByCommissionAmountDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getTop6CustomersByBillingDashboard(
        partnerId: number | undefined,
        spmId: number | undefined
    ): Observable<Top6CustomersByBillingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetTop6CustomersByBillingDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTop6CustomersByBillingDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTop6CustomersByBillingDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<Top6CustomersByBillingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Top6CustomersByBillingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTop6CustomersByBillingDashboard(response: HttpResponseBase): Observable<Top6CustomersByBillingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Top6CustomersByBillingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Top6CustomersByBillingDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getTop6ProvidersByCommissionDashboard(
        partnerId: number | undefined,
        spmId: number | undefined
    ): Observable<Top6ProvidersByCommissionDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetTop6ProvidersByCommissionDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTop6ProvidersByCommissionDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTop6ProvidersByCommissionDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<Top6ProvidersByCommissionDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Top6ProvidersByCommissionDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTop6ProvidersByCommissionDashboard(
        response: HttpResponseBase
    ): Observable<Top6ProvidersByCommissionDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Top6ProvidersByCommissionDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Top6ProvidersByCommissionDashboardOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     */
    getTop6ProvidersByBillingDashboard(
        partnerId: number | undefined,
        spmId: number | undefined
    ): Observable<Top6ProvidersByBillingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetTop6ProvidersByBillingDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTop6ProvidersByBillingDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTop6ProvidersByBillingDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<Top6ProvidersByBillingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Top6ProvidersByBillingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTop6ProvidersByBillingDashboard(response: HttpResponseBase): Observable<Top6ProvidersByBillingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Top6ProvidersByBillingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Top6ProvidersByBillingDashboardOutput[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getReportCommissionOrderRevenueVariance(month: number | undefined, year: number | undefined): Observable<CommissionOrderVarianceDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionOrderRevenueVariance?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionOrderRevenueVariance(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionOrderRevenueVariance(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionOrderVarianceDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionOrderVarianceDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionOrderRevenueVariance(response: HttpResponseBase): Observable<CommissionOrderVarianceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionOrderVarianceDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionOrderVarianceDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerId (optional)
     * @return Success
     */
    getReportCommissionForecast(
        month: number | undefined,
        year: number | undefined,
        partnerId: number | undefined
    ): Observable<CommissionForecastOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionForecast?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionForecast(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionForecast(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionForecastOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionForecastOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionForecast(response: HttpResponseBase): Observable<CommissionForecastOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionForecastOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionForecastOutput[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param customerName (optional)
     * @param commissionStatus (optional)
     * @param selectedMaster (optional)
     * @param customerId (optional)
     * @return Success
     */
    getCommissionDetailToExcel(
        month: number | undefined,
        year: number | undefined,
        providerId: string | undefined,
        partnerId: string | undefined,
        customerName: string | undefined,
        commissionStatus: string | undefined,
        selectedMaster: number | undefined,
        customerId: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionDetailToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'customerName=' + encodeURIComponent('' + customerName) + '&';
        if (commissionStatus === null) throw new Error("The parameter 'commissionStatus' cannot be null.");
        else if (commissionStatus !== undefined) url_ += 'commissionStatus=' + encodeURIComponent('' + commissionStatus) + '&';
        if (selectedMaster === null) throw new Error("The parameter 'selectedMaster' cannot be null.");
        else if (selectedMaster !== undefined) url_ += 'SelectedMaster=' + encodeURIComponent('' + selectedMaster) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'customerId=' + encodeURIComponent('' + customerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionDetailToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionDetailToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionDetailToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerAcquisitionIds (optional)
     * @param uploaderType (optional)
     * @return Success
     */
    getPayoutCommissionAsCSVFile(
        month: number | undefined,
        year: number | undefined,
        partnerAcquisitionIds: string | undefined,
        uploaderType: ReportUploaderType | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetPayoutCommissionAsCSVFile?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (partnerAcquisitionIds === null) throw new Error("The parameter 'partnerAcquisitionIds' cannot be null.");
        else if (partnerAcquisitionIds !== undefined)
            url_ += 'partnerAcquisitionIds=' + encodeURIComponent('' + partnerAcquisitionIds) + '&';
        if (uploaderType === null) throw new Error("The parameter 'uploaderType' cannot be null.");
        else if (uploaderType !== undefined) url_ += 'uploaderType=' + encodeURIComponent('' + uploaderType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPayoutCommissionAsCSVFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPayoutCommissionAsCSVFile(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPayoutCommissionAsCSVFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerAcquisitionIds (optional)
     * @param uploaderType (optional)
     * @return Success
     */
    getPayoutAdjustmentToExcel(
        month: number | undefined,
        year: number | undefined,
        partnerAcquisitionIds: string | undefined,
        uploaderType: ReportUploaderType | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetPayoutAdjustmentToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (partnerAcquisitionIds === null) throw new Error("The parameter 'partnerAcquisitionIds' cannot be null.");
        else if (partnerAcquisitionIds !== undefined)
            url_ += 'partnerAcquisitionIds=' + encodeURIComponent('' + partnerAcquisitionIds) + '&';
        if (uploaderType === null) throw new Error("The parameter 'uploaderType' cannot be null.");
        else if (uploaderType !== undefined) url_ += 'uploaderType=' + encodeURIComponent('' + uploaderType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPayoutAdjustmentToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPayoutAdjustmentToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPayoutAdjustmentToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param partnerAcquisitionIds (optional)
     * @param uploaderType (optional)
     * @return Success
     */
    getPayoutHoldToExcel(
        month: number | undefined,
        year: number | undefined,
        partnerAcquisitionIds: string | undefined,
        uploaderType: ReportUploaderType | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetPayoutHoldToExcel?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        if (partnerAcquisitionIds === null) throw new Error("The parameter 'partnerAcquisitionIds' cannot be null.");
        else if (partnerAcquisitionIds !== undefined)
            url_ += 'partnerAcquisitionIds=' + encodeURIComponent('' + partnerAcquisitionIds) + '&';
        if (uploaderType === null) throw new Error("The parameter 'uploaderType' cannot be null.");
        else if (uploaderType !== undefined) url_ += 'uploaderType=' + encodeURIComponent('' + uploaderType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPayoutHoldToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPayoutHoldToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPayoutHoldToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    enqueuePayoutCommissionGenerationJob(body: CommissionUploaderInput | undefined): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/EnqueuePayoutCommissionGenerationJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueuePayoutCommissionGenerationJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueuePayoutCommissionGenerationJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueuePayoutCommissionGenerationJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    enqueuePayoutAdjustmentGenerationJob(body: CommissionUploaderInput | undefined): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/EnqueuePayoutAdjustmentGenerationJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueuePayoutAdjustmentGenerationJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueuePayoutAdjustmentGenerationJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueuePayoutAdjustmentGenerationJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    enqueuePayoutHoldGenerationJob(body: CommissionUploaderInput | undefined): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/EnqueuePayoutHoldGenerationJob';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueuePayoutHoldGenerationJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueuePayoutHoldGenerationJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueuePayoutHoldGenerationJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCommissionsByProviderByAdvisorReport(month: number, year: number): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionsByProviderByAdvisorReport?';
        if (month === undefined || month === null) throw new Error("The parameter 'month' must be defined and cannot be null.");
        else url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined and cannot be null.");
        else url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionsByProviderByAdvisorReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionsByProviderByAdvisorReport(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionsByProviderByAdvisorReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBookingReport(start: moment.Moment, end: moment.Moment): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetBookingReport?';
        if (start === undefined || start === null) throw new Error("The parameter 'start' must be defined and cannot be null.");
        else url_ += 'Start=' + encodeURIComponent(start ? '' + start.toJSON() : '') + '&';
        if (end === undefined || end === null) throw new Error("The parameter 'end' must be defined and cannot be null.");
        else url_ += 'End=' + encodeURIComponent(end ? '' + end.toJSON() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetBookingReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetBookingReport(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetBookingReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param providerId (optional)
     * @param advisorId (optional)
     * @param billingAccountNumber (optional)
     * @param billingAccountName (optional)
     * @return Success
     */
    getReportCommissionHistory(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        providerId: number | undefined,
        advisorId: number | undefined,
        billingAccountNumber: string | undefined,
        billingAccountName: string | undefined
    ): Observable<CommissionHistoryReportOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionHistory?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'StartMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'StartYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'EndMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'EndYear=' + encodeURIComponent('' + endYear) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (billingAccountName === null) throw new Error("The parameter 'billingAccountName' cannot be null.");
        else if (billingAccountName !== undefined) url_ += 'BillingAccountName=' + encodeURIComponent('' + billingAccountName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionHistory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionHistory(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionHistoryReportOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionHistoryReportOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionHistory(response: HttpResponseBase): Observable<CommissionHistoryReportOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionHistoryReportOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionHistoryReportOutput[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param providerId (optional)
     * @param advisorId (optional)
     * @param billingAccountNumber (optional)
     * @param billingAccountName (optional)
     * @return Success
     */
    getReportCommissionHistoryToExcel(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        providerId: number | undefined,
        advisorId: number | undefined,
        billingAccountNumber: string | undefined,
        billingAccountName: string | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetReportCommissionHistoryToExcel?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'StartMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'StartYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'EndMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'EndYear=' + encodeURIComponent('' + endYear) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (billingAccountName === null) throw new Error("The parameter 'billingAccountName' cannot be null.");
        else if (billingAccountName !== undefined) url_ += 'BillingAccountName=' + encodeURIComponent('' + billingAccountName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportCommissionHistoryToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportCommissionHistoryToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportCommissionHistoryToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAdjustmentDetails(id: number | undefined): Observable<CommissionReviewDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAdjustmentDetails?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustmentDetails(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustmentDetails(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustmentDetails(response: HttpResponseBase): Observable<CommissionReviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionReviewDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAdjustmentActionNote(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetAdjustmentActionNote?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustmentActionNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustmentActionNote(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustmentActionNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param actionId (optional)
     * @param note (optional)
     * @return Success
     */
    updateAdjustmentActionNote(actionId: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateAdjustmentActionNote?';
        if (actionId === null) throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined) url_ += 'actionId=' + encodeURIComponent('' + actionId) + '&';
        if (note === null) throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined) url_ += 'note=' + encodeURIComponent('' + note) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAdjustmentActionNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAdjustmentActionNote(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateAdjustmentActionNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param commissionId (optional)
     * @return Success
     */
    getCommissionNote(commissionId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionNote?';
        if (commissionId === null) throw new Error("The parameter 'commissionId' cannot be null.");
        else if (commissionId !== undefined) url_ += 'commissionId=' + encodeURIComponent('' + commissionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionNote(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param commissionId (optional)
     * @param note (optional)
     * @return Success
     */
    updateCommissionNote(commissionId: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/UpdateCommissionNote?';
        if (commissionId === null) throw new Error("The parameter 'commissionId' cannot be null.");
        else if (commissionId !== undefined) url_ += 'commissionId=' + encodeURIComponent('' + commissionId) + '&';
        if (note === null) throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined) url_ += 'note=' + encodeURIComponent('' + note) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCommissionNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCommissionNote(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCommissionNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createCommissionBulkAdjustments(body: CommissionBulkAdjustmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Commission/CreateCommissionBulkAdjustments';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateCommissionBulkAdjustments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateCommissionBulkAdjustments(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateCommissionBulkAdjustments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCommissionTemplateDetailsFields(): Observable<CommissionField[]> {
        let url_ = this.baseUrl + '/api/services/app/Commission/GetCommissionTemplateDetailsFields';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionTemplateDetailsFields(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionTemplateDetailsFields(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionField[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionField[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionTemplateDetailsFields(response: HttpResponseBase): Observable<CommissionField[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionField.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionField[]>([]);
    }
}

@Injectable()
export class CommissionChurnReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getVarianceValues(): Observable<Int64IdNameDto[]> {
        let url_ = this.baseUrl + '/api/services/app/CommissionChurnReport/GetVarianceValues';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetVarianceValues(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetVarianceValues(<any>response_);
                        } catch (e) {
                            return <Observable<Int64IdNameDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<Int64IdNameDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetVarianceValues(response: HttpResponseBase): Observable<Int64IdNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(Int64IdNameDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<Int64IdNameDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param supportId (optional)
     * @param varianceValue (optional)
     * @param varienceDirection (optional)
     * @param includeCommissionTermOnPayment (optional)
     * @param isMicrocorpRevenue (optional)
     * @param isMcUser (optional)
     * @return Success
     */
    getCommissionChurns(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        partnerId: number | undefined,
        supportId: number | undefined,
        varianceValue: number | undefined,
        varienceDirection: number | undefined,
        includeCommissionTermOnPayment: boolean | undefined,
        isMicrocorpRevenue: boolean | undefined,
        isMcUser: boolean | undefined
    ): Observable<CommissionChurnDto[]> {
        let url_ = this.baseUrl + '/api/services/app/CommissionChurnReport/GetCommissionChurns?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'SupportId=' + encodeURIComponent('' + supportId) + '&';
        if (varianceValue === null) throw new Error("The parameter 'varianceValue' cannot be null.");
        else if (varianceValue !== undefined) url_ += 'VarianceValue=' + encodeURIComponent('' + varianceValue) + '&';
        if (varienceDirection === null) throw new Error("The parameter 'varienceDirection' cannot be null.");
        else if (varienceDirection !== undefined) url_ += 'VarienceDirection=' + encodeURIComponent('' + varienceDirection) + '&';
        if (includeCommissionTermOnPayment === null) throw new Error("The parameter 'includeCommissionTermOnPayment' cannot be null.");
        else if (includeCommissionTermOnPayment !== undefined)
            url_ += 'IncludeCommissionTermOnPayment=' + encodeURIComponent('' + includeCommissionTermOnPayment) + '&';
        if (isMicrocorpRevenue === null) throw new Error("The parameter 'isMicrocorpRevenue' cannot be null.");
        else if (isMicrocorpRevenue !== undefined) url_ += 'IsMicrocorpRevenue=' + encodeURIComponent('' + isMicrocorpRevenue) + '&';
        if (isMcUser === null) throw new Error("The parameter 'isMcUser' cannot be null.");
        else if (isMcUser !== undefined) url_ += 'IsMcUser=' + encodeURIComponent('' + isMcUser) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionChurns(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionChurns(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionChurnDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionChurnDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionChurns(response: HttpResponseBase): Observable<CommissionChurnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionChurnDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionChurnDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @param providerId (optional)
     * @param partnerId (optional)
     * @param supportId (optional)
     * @param varianceValue (optional)
     * @param varienceDirection (optional)
     * @param includeCommissionTermOnPayment (optional)
     * @param isMicrocorpRevenue (optional)
     * @param isMcUser (optional)
     * @return Success
     */
    getChurnDashboardStatistics(
        month: number | undefined,
        year: number | undefined,
        providerId: number | undefined,
        partnerId: number | undefined,
        supportId: number | undefined,
        varianceValue: number | undefined,
        varienceDirection: number | undefined,
        includeCommissionTermOnPayment: boolean | undefined,
        isMicrocorpRevenue: boolean | undefined,
        isMcUser: boolean | undefined
    ): Observable<ChurnDashboardStatisticsDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionChurnReport/GetChurnDashboardStatistics?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'Month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'SupportId=' + encodeURIComponent('' + supportId) + '&';
        if (varianceValue === null) throw new Error("The parameter 'varianceValue' cannot be null.");
        else if (varianceValue !== undefined) url_ += 'VarianceValue=' + encodeURIComponent('' + varianceValue) + '&';
        if (varienceDirection === null) throw new Error("The parameter 'varienceDirection' cannot be null.");
        else if (varienceDirection !== undefined) url_ += 'VarienceDirection=' + encodeURIComponent('' + varienceDirection) + '&';
        if (includeCommissionTermOnPayment === null) throw new Error("The parameter 'includeCommissionTermOnPayment' cannot be null.");
        else if (includeCommissionTermOnPayment !== undefined)
            url_ += 'IncludeCommissionTermOnPayment=' + encodeURIComponent('' + includeCommissionTermOnPayment) + '&';
        if (isMicrocorpRevenue === null) throw new Error("The parameter 'isMicrocorpRevenue' cannot be null.");
        else if (isMicrocorpRevenue !== undefined) url_ += 'IsMicrocorpRevenue=' + encodeURIComponent('' + isMicrocorpRevenue) + '&';
        if (isMcUser === null) throw new Error("The parameter 'isMcUser' cannot be null.");
        else if (isMcUser !== undefined) url_ += 'IsMcUser=' + encodeURIComponent('' + isMcUser) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetChurnDashboardStatistics(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetChurnDashboardStatistics(<any>response_);
                        } catch (e) {
                            return <Observable<ChurnDashboardStatisticsDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ChurnDashboardStatisticsDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetChurnDashboardStatistics(response: HttpResponseBase): Observable<ChurnDashboardStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ChurnDashboardStatisticsDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ChurnDashboardStatisticsDto>(<any>null);
    }
}

@Injectable()
export class CommissionProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getSPMPartnerDetail(partnerId: number | undefined): Observable<OuptutSPMDetailsDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionProcess/GetSPMPartnerDetail?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSPMPartnerDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSPMPartnerDetail(<any>response_);
                        } catch (e) {
                            return <Observable<OuptutSPMDetailsDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OuptutSPMDetailsDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSPMPartnerDetail(response: HttpResponseBase): Observable<OuptutSPMDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = OuptutSPMDetailsDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OuptutSPMDetailsDto>(<any>null);
    }
}

@Injectable()
export class CommissionReviewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param onlyHolds (optional)
     * @return Success
     */
    getCommissionReviewSummaries(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        onlyHolds: boolean | undefined
    ): Observable<CommissionReviewsSummaryOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetCommissionReviewSummaries?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReviewSummaries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReviewSummaries(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewsSummaryOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewsSummaryOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReviewSummaries(response: HttpResponseBase): Observable<CommissionReviewsSummaryOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommissionReviewsSummaryOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewsSummaryOutput[]>([]);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param onlyHolds (optional)
     * @return Success
     */
    getCommissionAdjustmentSummaries(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        onlyHolds: boolean | undefined
    ): Observable<CommissionReviewsSummaryOutput> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetCommissionAdjustmentSummaries?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionAdjustmentSummaries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionAdjustmentSummaries(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewsSummaryOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewsSummaryOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionAdjustmentSummaries(response: HttpResponseBase): Observable<CommissionReviewsSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReviewsSummaryOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewsSummaryOutput>(<any>null);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param isAdjustment (optional)
     * @param onlyHolds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionReviews(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        isAdjustment: boolean | undefined,
        onlyHolds: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionReviewDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetCommissionReviews?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (isAdjustment === null) throw new Error("The parameter 'isAdjustment' cannot be null.");
        else if (isAdjustment !== undefined) url_ += 'IsAdjustment=' + encodeURIComponent('' + isAdjustment) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReviews(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReviews(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReviews(response: HttpResponseBase): Observable<CommissionReviewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReviewDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewDtoPagedResultDto>(<any>null);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param isAdjustment (optional)
     * @param onlyHolds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCommissionReviewsForBulkAdjustment(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        isAdjustment: boolean | undefined,
        onlyHolds: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionReviewDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetCommissionReviewsForBulkAdjustment?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (isAdjustment === null) throw new Error("The parameter 'isAdjustment' cannot be null.");
        else if (isAdjustment !== undefined) url_ += 'IsAdjustment=' + encodeURIComponent('' + isAdjustment) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionReviewsForBulkAdjustment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionReviewsForBulkAdjustment(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionReviewsForBulkAdjustment(response: HttpResponseBase): Observable<CommissionReviewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReviewDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    exportCommissionReviews(body: CommissionReviewFiltersInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/ExportCommissionReviews';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processExportCommissionReviews(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processExportCommissionReviews(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processExportCommissionReviews(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param onlyHolds (optional)
     * @return Success
     */
    getCounts(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        onlyHolds: boolean | undefined
    ): Observable<CommissionReviewsCountsOutput> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetCounts?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCounts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCounts(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionReviewsCountsOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionReviewsCountsOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCounts(response: HttpResponseBase): Observable<CommissionReviewsCountsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionReviewsCountsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionReviewsCountsOutput>(<any>null);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param isAdjustment (optional)
     * @param onlyHolds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAdjustments(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        isAdjustment: boolean | undefined,
        onlyHolds: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<CommissionAdjustmentsOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetAdjustments?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (isAdjustment === null) throw new Error("The parameter 'isAdjustment' cannot be null.");
        else if (isAdjustment !== undefined) url_ += 'IsAdjustment=' + encodeURIComponent('' + isAdjustment) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustments(<any>response_);
                        } catch (e) {
                            return <Observable<CommissionAdjustmentsOutputDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommissionAdjustmentsOutputDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustments(response: HttpResponseBase): Observable<CommissionAdjustmentsOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommissionAdjustmentsOutputDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommissionAdjustmentsOutputDtoPagedResultDto>(<any>null);
    }

    /**
     * @param commissionWorkbookIds (optional)
     * @param bulkAdjustmentActionIds (optional)
     * @return Success
     */
    deleteAdjustments(commissionWorkbookIds: number[] | undefined, bulkAdjustmentActionIds: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/DeleteAdjustments?';
        if (commissionWorkbookIds === null) throw new Error("The parameter 'commissionWorkbookIds' cannot be null.");
        else if (commissionWorkbookIds !== undefined)
            commissionWorkbookIds &&
                commissionWorkbookIds.forEach((item) => {
                    url_ += 'CommissionWorkbookIds=' + encodeURIComponent('' + item) + '&';
                });
        if (bulkAdjustmentActionIds === null) throw new Error("The parameter 'bulkAdjustmentActionIds' cannot be null.");
        else if (bulkAdjustmentActionIds !== undefined)
            bulkAdjustmentActionIds &&
                bulkAdjustmentActionIds.forEach((item) => {
                    url_ += 'BulkAdjustmentActionIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAdjustments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAdjustments(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAdjustments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param cycleStart (optional)
     * @param cycleEnd (optional)
     * @param billingAccountNumber (optional)
     * @param masterAgencyId (optional)
     * @param providerId (optional)
     * @param providerStatementId (optional)
     * @param advisorId (optional)
     * @param onlyHolds (optional)
     * @return Success
     */
    getAdjustmentsReport(
        cycleStart: moment.Moment | undefined,
        cycleEnd: moment.Moment | undefined,
        billingAccountNumber: string | undefined,
        masterAgencyId: number | undefined,
        providerId: number | undefined,
        providerStatementId: number | undefined,
        advisorId: number | undefined,
        onlyHolds: boolean | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/CommissionReviews/GetAdjustmentsReport?';
        if (cycleStart === null) throw new Error("The parameter 'cycleStart' cannot be null.");
        else if (cycleStart !== undefined) url_ += 'CycleStart=' + encodeURIComponent(cycleStart ? '' + cycleStart.toJSON() : '') + '&';
        if (cycleEnd === null) throw new Error("The parameter 'cycleEnd' cannot be null.");
        else if (cycleEnd !== undefined) url_ += 'CycleEnd=' + encodeURIComponent(cycleEnd ? '' + cycleEnd.toJSON() : '') + '&';
        if (billingAccountNumber === null) throw new Error("The parameter 'billingAccountNumber' cannot be null.");
        else if (billingAccountNumber !== undefined) url_ += 'BillingAccountNumber=' + encodeURIComponent('' + billingAccountNumber) + '&';
        if (masterAgencyId === null) throw new Error("The parameter 'masterAgencyId' cannot be null.");
        else if (masterAgencyId !== undefined) url_ += 'MasterAgencyId=' + encodeURIComponent('' + masterAgencyId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (providerStatementId === null) throw new Error("The parameter 'providerStatementId' cannot be null.");
        else if (providerStatementId !== undefined) url_ += 'ProviderStatementId=' + encodeURIComponent('' + providerStatementId) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'AdvisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (onlyHolds === null) throw new Error("The parameter 'onlyHolds' cannot be null.");
        else if (onlyHolds !== undefined) url_ += 'OnlyHolds=' + encodeURIComponent('' + onlyHolds) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdjustmentsReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdjustmentsReport(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdjustmentsReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class BackgroundJobCancellationRequestDto implements IBackgroundJobCancellationRequestDto {
    id: number;
    createdTime: moment.Moment;

    constructor(data?: IBackgroundJobCancellationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.createdTime = _data['createdTime'] ? moment(_data['createdTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BackgroundJobCancellationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobCancellationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['createdTime'] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): BackgroundJobCancellationRequestDto {
        const json = this.toJSON();
        let result = new BackgroundJobCancellationRequestDto();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobCancellationRequestDto {
    id: number;
    createdTime: moment.Moment;
}

export interface IBackgroundJobExecutionDto {
    id: number;
    uuid: string;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    source: string | undefined;
    status: BackgroundJobExecutionStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    failureReason: string | undefined;
    metadata: string | undefined;
    jobResult: string | undefined;
    cancellationRequests: BackgroundJobCancellationRequestDto[] | undefined;
    output: BackgroundJobOutputDto;
    creatorFirstName: string | undefined;
    creatorLastName: string | undefined;
}

export enum BackgroundJobExecutionStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class BackgroundJobOutputDto implements IBackgroundJobOutputDto {
    dynamicOutput: any | undefined;
    files: BackgroundJobOutputFileDto[] | undefined;
    logs: BackgroundJobOutputLogDto[] | undefined;

    constructor(data?: IBackgroundJobOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicOutput = _data['dynamicOutput'];
            if (Array.isArray(_data['files'])) {
                this.files = [] as any;
                for (let item of _data['files']) this.files.push(BackgroundJobOutputFileDto.fromJS(item));
            }
            if (Array.isArray(_data['logs'])) {
                this.logs = [] as any;
                for (let item of _data['logs']) this.logs.push(BackgroundJobOutputLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackgroundJobOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['dynamicOutput'] = this.dynamicOutput;
        if (Array.isArray(this.files)) {
            data['files'] = [];
            for (let item of this.files) data['files'].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data['logs'] = [];
            for (let item of this.logs) data['logs'].push(item.toJSON());
        }
        return data;
    }

    clone(): BackgroundJobOutputDto {
        const json = this.toJSON();
        let result = new BackgroundJobOutputDto();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobOutputDto {
    dynamicOutput: any | undefined;
    files: BackgroundJobOutputFileDto[] | undefined;
    logs: BackgroundJobOutputLogDto[] | undefined;
}

export class BackgroundJobOutputFileDto implements IBackgroundJobOutputFileDto {
    fileName: string | undefined;
    contentType: string | undefined;
    storagePath: string | undefined;

    constructor(data?: IBackgroundJobOutputFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.contentType = _data['contentType'];
            this.storagePath = _data['storagePath'];
        }
    }

    static fromJS(data: any): BackgroundJobOutputFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobOutputFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['contentType'] = this.contentType;
        data['storagePath'] = this.storagePath;
        return data;
    }

    clone(): BackgroundJobOutputFileDto {
        const json = this.toJSON();
        let result = new BackgroundJobOutputFileDto();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobOutputFileDto {
    fileName: string | undefined;
    contentType: string | undefined;
    storagePath: string | undefined;
}

export class BackgroundJobOutputLogDto implements IBackgroundJobOutputLogDto {
    date: moment.Moment;
    level: LogLevel;
    message: string | undefined;

    constructor(data?: IBackgroundJobOutputLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            this.level = _data['level'];
            this.message = _data['message'];
        }
    }

    static fromJS(data: any): BackgroundJobOutputLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobOutputLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        data['level'] = this.level;
        data['message'] = this.message;
        return data;
    }

    clone(): BackgroundJobOutputLogDto {
        const json = this.toJSON();
        let result = new BackgroundJobOutputLogDto();
        result.init(json);
        return result;
    }
}

export interface IBackgroundJobOutputLogDto {
    date: moment.Moment;
    level: LogLevel;
    message: string | undefined;
}

export class BulkAdjustmentActionDto implements IBulkAdjustmentActionDto {
    id: number;
    salesAgentId: number | undefined;
    rate: number | undefined;
    creationTime: moment.Moment;

    constructor(data?: IBulkAdjustmentActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.salesAgentId = _data['salesAgentId'];
            this.rate = _data['rate'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkAdjustmentActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAdjustmentActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['salesAgentId'] = this.salesAgentId;
        data['rate'] = this.rate;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): BulkAdjustmentActionDto {
        const json = this.toJSON();
        let result = new BulkAdjustmentActionDto();
        result.init(json);
        return result;
    }
}

export interface IBulkAdjustmentActionDto {
    id: number;
    salesAgentId: number | undefined;
    rate: number | undefined;
    creationTime: moment.Moment;
}

export class ChurnDashboardStatisticsDto implements IChurnDashboardStatisticsDto {
    currentChurnValue: number | undefined;
    currentChurnPercent: number | undefined;
    totalCustomerValue: number | undefined;
    totalCustomerPercent: number | undefined;
    threeMonthAverageValue: number | undefined;

    constructor(data?: IChurnDashboardStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentChurnValue = _data['currentChurnValue'];
            this.currentChurnPercent = _data['currentChurnPercent'];
            this.totalCustomerValue = _data['totalCustomerValue'];
            this.totalCustomerPercent = _data['totalCustomerPercent'];
            this.threeMonthAverageValue = _data['threeMonthAverageValue'];
        }
    }

    static fromJS(data: any): ChurnDashboardStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChurnDashboardStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['currentChurnValue'] = this.currentChurnValue;
        data['currentChurnPercent'] = this.currentChurnPercent;
        data['totalCustomerValue'] = this.totalCustomerValue;
        data['totalCustomerPercent'] = this.totalCustomerPercent;
        data['threeMonthAverageValue'] = this.threeMonthAverageValue;
        return data;
    }

    clone(): ChurnDashboardStatisticsDto {
        const json = this.toJSON();
        let result = new ChurnDashboardStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IChurnDashboardStatisticsDto {
    currentChurnValue: number | undefined;
    currentChurnPercent: number | undefined;
    totalCustomerValue: number | undefined;
    totalCustomerPercent: number | undefined;
    threeMonthAverageValue: number | undefined;
}

export class CommissionAdjustmentDto implements ICommissionAdjustmentDto {
    id: number;
    workbookDetailId: number;
    month: number;
    year: number;
    providerId: number;
    partnerId: number;
    partnerName: string | undefined;
    strategicPartnerManagerId: number;
    strategicPartnerManagerName: string | undefined;
    billingAccountNumber: string;
    billingAccountName: string;
    providerRevenue: number;
    productName: string | undefined;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    salesAgentId: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    isAdjustment: boolean;
    masterAgencyId: number;
    partnerOrderNumber: string | undefined;

    constructor(data?: ICommissionAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.workbookDetailId = _data['workbookDetailId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.providerId = _data['providerId'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.strategicPartnerManagerId = _data['strategicPartnerManagerId'];
            this.strategicPartnerManagerName = _data['strategicPartnerManagerName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.providerRevenue = _data['providerRevenue'];
            this.productName = _data['productName'];
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.reference = _data['reference'];
            this.note = _data['note'];
            this.mcCommissionPercent = _data['mcCommissionPercent'];
            this.mcmrrCommission = _data['mcmrrCommission'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgentName = _data['salesAgentName'];
            this.salesAgentSplitRate = _data['salesAgentSplitRate'];
            this.salesAgentCommissionPercent = _data['salesAgentCommissionPercent'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.isAdjustment = _data['isAdjustment'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
        }
    }

    static fromJS(data: any): CommissionAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['workbookDetailId'] = this.workbookDetailId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['providerId'] = this.providerId;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['strategicPartnerManagerId'] = this.strategicPartnerManagerId;
        data['strategicPartnerManagerName'] = this.strategicPartnerManagerName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['providerRevenue'] = this.providerRevenue;
        data['productName'] = this.productName;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['reference'] = this.reference;
        data['note'] = this.note;
        data['mcCommissionPercent'] = this.mcCommissionPercent;
        data['mcmrrCommission'] = this.mcmrrCommission;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgentName'] = this.salesAgentName;
        data['salesAgentSplitRate'] = this.salesAgentSplitRate;
        data['salesAgentCommissionPercent'] = this.salesAgentCommissionPercent;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['isAdjustment'] = this.isAdjustment;
        data['masterAgencyId'] = this.masterAgencyId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        return data;
    }

    clone(): CommissionAdjustmentDto {
        const json = this.toJSON();
        let result = new CommissionAdjustmentDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionAdjustmentDto {
    id: number;
    workbookDetailId: number;
    month: number;
    year: number;
    providerId: number;
    partnerId: number;
    partnerName: string | undefined;
    strategicPartnerManagerId: number;
    strategicPartnerManagerName: string | undefined;
    billingAccountNumber: string;
    billingAccountName: string;
    providerRevenue: number;
    productName: string | undefined;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    salesAgentId: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    isAdjustment: boolean;
    masterAgencyId: number;
    partnerOrderNumber: string | undefined;
}

export class CommissionAdjustmentsOutputDto implements ICommissionAdjustmentsOutputDto {
    bulkAdjustmentAction: BulkAdjustmentActionDto;
    commissionWorkbooks: CommissionWorkbookDto[] | undefined;
    commissionReviews: CommissionReviewDto[] | undefined;

    constructor(data?: ICommissionAdjustmentsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkAdjustmentAction = _data['bulkAdjustmentAction']
                ? BulkAdjustmentActionDto.fromJS(_data['bulkAdjustmentAction'])
                : <any>undefined;
            if (Array.isArray(_data['commissionWorkbooks'])) {
                this.commissionWorkbooks = [] as any;
                for (let item of _data['commissionWorkbooks']) this.commissionWorkbooks.push(CommissionWorkbookDto.fromJS(item));
            }
            if (Array.isArray(_data['commissionReviews'])) {
                this.commissionReviews = [] as any;
                for (let item of _data['commissionReviews']) this.commissionReviews.push(CommissionReviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionAdjustmentsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionAdjustmentsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['bulkAdjustmentAction'] = this.bulkAdjustmentAction ? this.bulkAdjustmentAction.toJSON() : <any>undefined;
        if (Array.isArray(this.commissionWorkbooks)) {
            data['commissionWorkbooks'] = [];
            for (let item of this.commissionWorkbooks) data['commissionWorkbooks'].push(item.toJSON());
        }
        if (Array.isArray(this.commissionReviews)) {
            data['commissionReviews'] = [];
            for (let item of this.commissionReviews) data['commissionReviews'].push(item.toJSON());
        }
        return data;
    }

    clone(): CommissionAdjustmentsOutputDto {
        const json = this.toJSON();
        let result = new CommissionAdjustmentsOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionAdjustmentsOutputDto {
    bulkAdjustmentAction: BulkAdjustmentActionDto;
    commissionWorkbooks: CommissionWorkbookDto[] | undefined;
    commissionReviews: CommissionReviewDto[] | undefined;
}

export class CommissionAdjustmentsOutputDtoPagedResultDto implements ICommissionAdjustmentsOutputDtoPagedResultDto {
    totalCount: number;
    items: CommissionAdjustmentsOutputDto[] | undefined;

    constructor(data?: ICommissionAdjustmentsOutputDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CommissionAdjustmentsOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionAdjustmentsOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionAdjustmentsOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CommissionAdjustmentsOutputDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommissionAdjustmentsOutputDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionAdjustmentsOutputDtoPagedResultDto {
    totalCount: number;
    items: CommissionAdjustmentsOutputDto[] | undefined;
}

export class CommissionAmountDashboardOutput implements ICommissionAmountDashboardOutput {
    date: string | undefined;
    commissionAmount: number;

    constructor(data?: ICommissionAmountDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'];
            this.commissionAmount = _data['commissionAmount'];
        }
    }

    static fromJS(data: any): CommissionAmountDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionAmountDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date;
        data['commissionAmount'] = this.commissionAmount;
        return data;
    }

    clone(): CommissionAmountDashboardOutput {
        const json = this.toJSON();
        let result = new CommissionAmountDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionAmountDashboardOutput {
    date: string | undefined;
    commissionAmount: number;
}

export class CommissionBulkAdjustmentInput implements ICommissionBulkAdjustmentInput {
    statementPeriod: moment.Moment;
    commissionWorkDetailIds: number[] | undefined;
    reason: string;
    advisorId: number | undefined;
    salesAgentId: number | undefined;
    rate: number | undefined;
    applyRateForFuture: boolean;
    note: string | undefined;
    ticketId: number | undefined;

    constructor(data?: ICommissionBulkAdjustmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementPeriod = _data['statementPeriod'] ? moment(_data['statementPeriod'].toString()) : <any>undefined;
            if (Array.isArray(_data['commissionWorkDetailIds'])) {
                this.commissionWorkDetailIds = [] as any;
                for (let item of _data['commissionWorkDetailIds']) this.commissionWorkDetailIds.push(item);
            }
            this.reason = _data['reason'];
            this.advisorId = _data['advisorId'];
            this.salesAgentId = _data['salesAgentId'];
            this.rate = _data['rate'];
            this.applyRateForFuture = _data['applyRateForFuture'];
            this.note = _data['note'];
            this.ticketId = _data['ticketId'];
        }
    }

    static fromJS(data: any): CommissionBulkAdjustmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionBulkAdjustmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['statementPeriod'] = this.statementPeriod ? this.statementPeriod.toISOString() : <any>undefined;
        if (Array.isArray(this.commissionWorkDetailIds)) {
            data['commissionWorkDetailIds'] = [];
            for (let item of this.commissionWorkDetailIds) data['commissionWorkDetailIds'].push(item);
        }
        data['reason'] = this.reason;
        data['advisorId'] = this.advisorId;
        data['salesAgentId'] = this.salesAgentId;
        data['rate'] = this.rate;
        data['applyRateForFuture'] = this.applyRateForFuture;
        data['note'] = this.note;
        data['ticketId'] = this.ticketId;
        return data;
    }

    clone(): CommissionBulkAdjustmentInput {
        const json = this.toJSON();
        let result = new CommissionBulkAdjustmentInput();
        result.init(json);
        return result;
    }
}

export interface ICommissionBulkAdjustmentInput {
    statementPeriod: moment.Moment;
    commissionWorkDetailIds: number[] | undefined;
    reason: string;
    advisorId: number | undefined;
    salesAgentId: number | undefined;
    rate: number | undefined;
    applyRateForFuture: boolean;
    note: string | undefined;
    ticketId: number | undefined;
}

export class CommissionCalendarAllListDto implements ICommissionCalendarAllListDto {
    month: number;
    year: number;
    id: number;
    providerId: number;
    providerName: string | undefined;
    commissionManager: string | undefined;
    checkAmount: number;
    providerRevenue: number;
    mcMrrCommission: number;
    partnerCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    hasErrorFileUpload: boolean;
    reviewDate: moment.Moment | undefined;
    checkRegisterReviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    readonly variance: number;
    readonly margin: number;

    constructor(data?: ICommissionCalendarAllListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.commissionManager = _data['commissionManager'];
            this.checkAmount = _data['checkAmount'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcMrrCommission = _data['mcMrrCommission'];
            this.partnerCommissionPercent = _data['partnerCommissionPercent'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNrrCommission = _data['salesAgentNrrCommission'];
            this.fileReceivedDate = _data['fileReceivedDate'] ? moment(_data['fileReceivedDate'].toString()) : <any>undefined;
            this.fileUploadDate = _data['fileUploadDate'] ? moment(_data['fileUploadDate'].toString()) : <any>undefined;
            this.hasErrorFileUpload = _data['hasErrorFileUpload'];
            this.reviewDate = _data['reviewDate'] ? moment(_data['reviewDate'].toString()) : <any>undefined;
            this.checkRegisterReviewDate = _data['checkRegisterReviewDate']
                ? moment(_data['checkRegisterReviewDate'].toString())
                : <any>undefined;
            this.fileLockDate = _data['fileLockDate'] ? moment(_data['fileLockDate'].toString()) : <any>undefined;
            this.note = _data['note'];
            this.isLock = _data['isLock'];
            this.isReview = _data['isReview'];
            this.isClosed = _data['isClosed'];
            (<any>this).variance = _data['variance'];
            (<any>this).margin = _data['margin'];
        }
    }

    static fromJS(data: any): CommissionCalendarAllListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionCalendarAllListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['commissionManager'] = this.commissionManager;
        data['checkAmount'] = this.checkAmount;
        data['providerRevenue'] = this.providerRevenue;
        data['mcMrrCommission'] = this.mcMrrCommission;
        data['partnerCommissionPercent'] = this.partnerCommissionPercent;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNrrCommission'] = this.salesAgentNrrCommission;
        data['fileReceivedDate'] = this.fileReceivedDate ? this.fileReceivedDate.toISOString() : <any>undefined;
        data['fileUploadDate'] = this.fileUploadDate ? this.fileUploadDate.toISOString() : <any>undefined;
        data['hasErrorFileUpload'] = this.hasErrorFileUpload;
        data['reviewDate'] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data['checkRegisterReviewDate'] = this.checkRegisterReviewDate ? this.checkRegisterReviewDate.toISOString() : <any>undefined;
        data['fileLockDate'] = this.fileLockDate ? this.fileLockDate.toISOString() : <any>undefined;
        data['note'] = this.note;
        data['isLock'] = this.isLock;
        data['isReview'] = this.isReview;
        data['isClosed'] = this.isClosed;
        data['variance'] = this.variance;
        data['margin'] = this.margin;
        return data;
    }

    clone(): CommissionCalendarAllListDto {
        const json = this.toJSON();
        let result = new CommissionCalendarAllListDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionCalendarAllListDto {
    month: number;
    year: number;
    id: number;
    providerId: number;
    providerName: string | undefined;
    commissionManager: string | undefined;
    checkAmount: number;
    providerRevenue: number;
    mcMrrCommission: number;
    partnerCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    hasErrorFileUpload: boolean;
    reviewDate: moment.Moment | undefined;
    checkRegisterReviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    variance: number;
    margin: number;
}

export class CommissionCalendarDetailDto implements ICommissionCalendarDetailDto {
    id: number;
    templateName: string | undefined;
    checkAmount: number;
    mcMrrCommission: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    availableDate: moment.Moment | undefined;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    registerReviewDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    readonly variance: number;
    readonly margin: number;
    hasErrors: boolean;
    commissionTemplateId: number;
    commissionCalendarId: number;
    readonly hasAvailableDateWarning: boolean;
    isAdjustment: boolean;
    masterAgencyId: number;

    constructor(data?: ICommissionCalendarDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.templateName = _data['templateName'];
            this.checkAmount = _data['checkAmount'];
            this.mcMrrCommission = _data['mcMrrCommission'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNrrCommission = _data['salesAgentNrrCommission'];
            this.availableDate = _data['availableDate'] ? moment(_data['availableDate'].toString()) : <any>undefined;
            this.fileReceivedDate = _data['fileReceivedDate'] ? moment(_data['fileReceivedDate'].toString()) : <any>undefined;
            this.fileUploadDate = _data['fileUploadDate'] ? moment(_data['fileUploadDate'].toString()) : <any>undefined;
            this.registerReviewDate = _data['registerReviewDate'] ? moment(_data['registerReviewDate'].toString()) : <any>undefined;
            this.note = _data['note'];
            this.isLock = _data['isLock'];
            this.isReview = _data['isReview'];
            this.isClosed = _data['isClosed'];
            (<any>this).variance = _data['variance'];
            (<any>this).margin = _data['margin'];
            this.hasErrors = _data['hasErrors'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.commissionCalendarId = _data['commissionCalendarId'];
            (<any>this).hasAvailableDateWarning = _data['hasAvailableDateWarning'];
            this.isAdjustment = _data['isAdjustment'];
            this.masterAgencyId = _data['masterAgencyId'];
        }
    }

    static fromJS(data: any): CommissionCalendarDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionCalendarDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['templateName'] = this.templateName;
        data['checkAmount'] = this.checkAmount;
        data['mcMrrCommission'] = this.mcMrrCommission;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNrrCommission'] = this.salesAgentNrrCommission;
        data['availableDate'] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        data['fileReceivedDate'] = this.fileReceivedDate ? this.fileReceivedDate.toISOString() : <any>undefined;
        data['fileUploadDate'] = this.fileUploadDate ? this.fileUploadDate.toISOString() : <any>undefined;
        data['registerReviewDate'] = this.registerReviewDate ? this.registerReviewDate.toISOString() : <any>undefined;
        data['note'] = this.note;
        data['isLock'] = this.isLock;
        data['isReview'] = this.isReview;
        data['isClosed'] = this.isClosed;
        data['variance'] = this.variance;
        data['margin'] = this.margin;
        data['hasErrors'] = this.hasErrors;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['commissionCalendarId'] = this.commissionCalendarId;
        data['hasAvailableDateWarning'] = this.hasAvailableDateWarning;
        data['isAdjustment'] = this.isAdjustment;
        data['masterAgencyId'] = this.masterAgencyId;
        return data;
    }

    clone(): CommissionCalendarDetailDto {
        const json = this.toJSON();
        let result = new CommissionCalendarDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionCalendarDetailDto {
    id: number;
    templateName: string | undefined;
    checkAmount: number;
    mcMrrCommission: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    availableDate: moment.Moment | undefined;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    registerReviewDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    variance: number;
    margin: number;
    hasErrors: boolean;
    commissionTemplateId: number;
    commissionCalendarId: number;
    hasAvailableDateWarning: boolean;
    isAdjustment: boolean;
    masterAgencyId: number;
}

export class CommissionCalendarDto implements ICommissionCalendarDto {
    month: number;
    year: number;
    id: number;
    providerId: number;
    providerName: string | undefined;
    commissionManager: string | undefined;
    checkAmount: number;
    mcMrrCommission: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    reviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    hasDetails: boolean;
    variance: number;
    margin: number;
    hasErrorFileUpload: boolean;

    constructor(data?: ICommissionCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.commissionManager = _data['commissionManager'];
            this.checkAmount = _data['checkAmount'];
            this.mcMrrCommission = _data['mcMrrCommission'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNrrCommission = _data['salesAgentNrrCommission'];
            this.reviewDate = _data['reviewDate'] ? moment(_data['reviewDate'].toString()) : <any>undefined;
            this.fileLockDate = _data['fileLockDate'] ? moment(_data['fileLockDate'].toString()) : <any>undefined;
            this.note = _data['note'];
            this.isLock = _data['isLock'];
            this.isReview = _data['isReview'];
            this.isClosed = _data['isClosed'];
            this.hasDetails = _data['hasDetails'];
            this.variance = _data['variance'];
            this.margin = _data['margin'];
            this.hasErrorFileUpload = _data['hasErrorFileUpload'];
        }
    }

    static fromJS(data: any): CommissionCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['commissionManager'] = this.commissionManager;
        data['checkAmount'] = this.checkAmount;
        data['mcMrrCommission'] = this.mcMrrCommission;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNrrCommission'] = this.salesAgentNrrCommission;
        data['reviewDate'] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data['fileLockDate'] = this.fileLockDate ? this.fileLockDate.toISOString() : <any>undefined;
        data['note'] = this.note;
        data['isLock'] = this.isLock;
        data['isReview'] = this.isReview;
        data['isClosed'] = this.isClosed;
        data['hasDetails'] = this.hasDetails;
        data['variance'] = this.variance;
        data['margin'] = this.margin;
        data['hasErrorFileUpload'] = this.hasErrorFileUpload;
        return data;
    }

    clone(): CommissionCalendarDto {
        const json = this.toJSON();
        let result = new CommissionCalendarDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionCalendarDto {
    month: number;
    year: number;
    id: number;
    providerId: number;
    providerName: string | undefined;
    commissionManager: string | undefined;
    checkAmount: number;
    mcMrrCommission: number;
    salesAgentCommissionAmount: number;
    salesAgentNrrCommission: number;
    reviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    note: string | undefined;
    isLock: boolean;
    isReview: boolean;
    isClosed: boolean;
    hasDetails: boolean;
    variance: number;
    margin: number;
    hasErrorFileUpload: boolean;
}

export class CommissionCalendarEditDto implements ICommissionCalendarEditDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    month: number;
    year: number;
    note: string | undefined;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    reviewDate: moment.Moment | undefined;
    checkRegisterReviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    isReview: boolean;
    isLock: boolean;
    id: number;

    constructor(data?: ICommissionCalendarEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.month = _data['month'];
            this.year = _data['year'];
            this.note = _data['note'];
            this.fileReceivedDate = _data['fileReceivedDate'] ? moment(_data['fileReceivedDate'].toString()) : <any>undefined;
            this.fileUploadDate = _data['fileUploadDate'] ? moment(_data['fileUploadDate'].toString()) : <any>undefined;
            this.reviewDate = _data['reviewDate'] ? moment(_data['reviewDate'].toString()) : <any>undefined;
            this.checkRegisterReviewDate = _data['checkRegisterReviewDate']
                ? moment(_data['checkRegisterReviewDate'].toString())
                : <any>undefined;
            this.fileLockDate = _data['fileLockDate'] ? moment(_data['fileLockDate'].toString()) : <any>undefined;
            this.isReview = _data['isReview'];
            this.isLock = _data['isLock'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionCalendarEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionCalendarEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['month'] = this.month;
        data['year'] = this.year;
        data['note'] = this.note;
        data['fileReceivedDate'] = this.fileReceivedDate ? this.fileReceivedDate.toISOString() : <any>undefined;
        data['fileUploadDate'] = this.fileUploadDate ? this.fileUploadDate.toISOString() : <any>undefined;
        data['reviewDate'] = this.reviewDate ? this.reviewDate.toISOString() : <any>undefined;
        data['checkRegisterReviewDate'] = this.checkRegisterReviewDate ? this.checkRegisterReviewDate.toISOString() : <any>undefined;
        data['fileLockDate'] = this.fileLockDate ? this.fileLockDate.toISOString() : <any>undefined;
        data['isReview'] = this.isReview;
        data['isLock'] = this.isLock;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionCalendarEditDto {
        const json = this.toJSON();
        let result = new CommissionCalendarEditDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionCalendarEditDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    month: number;
    year: number;
    note: string | undefined;
    fileReceivedDate: moment.Moment | undefined;
    fileUploadDate: moment.Moment | undefined;
    reviewDate: moment.Moment | undefined;
    checkRegisterReviewDate: moment.Moment | undefined;
    fileLockDate: moment.Moment | undefined;
    isReview: boolean;
    isLock: boolean;
    id: number;
}

export class CommissionChurnDto implements ICommissionChurnDto {
    month: number;
    year: number;
    providerId: number;
    providerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    partnerOrderNumber: string | undefined;
    margin: number;
    selectedMonth: number;
    previousThreeMonthAverage: number | undefined;
    monthPrior: number | undefined;
    secondMonthPrior: number | undefined;
    thirdMonthPrior: number | undefined;
    varianceAmount: number;
    variancePercent: number;

    constructor(data?: ICommissionChurnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.margin = _data['margin'];
            this.selectedMonth = _data['selectedMonth'];
            this.previousThreeMonthAverage = _data['previousThreeMonthAverage'];
            this.monthPrior = _data['monthPrior'];
            this.secondMonthPrior = _data['secondMonthPrior'];
            this.thirdMonthPrior = _data['thirdMonthPrior'];
            this.varianceAmount = _data['varianceAmount'];
            this.variancePercent = _data['variancePercent'];
        }
    }

    static fromJS(data: any): CommissionChurnDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionChurnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['margin'] = this.margin;
        data['selectedMonth'] = this.selectedMonth;
        data['previousThreeMonthAverage'] = this.previousThreeMonthAverage;
        data['monthPrior'] = this.monthPrior;
        data['secondMonthPrior'] = this.secondMonthPrior;
        data['thirdMonthPrior'] = this.thirdMonthPrior;
        data['varianceAmount'] = this.varianceAmount;
        data['variancePercent'] = this.variancePercent;
        return data;
    }

    clone(): CommissionChurnDto {
        const json = this.toJSON();
        let result = new CommissionChurnDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionChurnDto {
    month: number;
    year: number;
    providerId: number;
    providerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    partnerOrderNumber: string | undefined;
    margin: number;
    selectedMonth: number;
    previousThreeMonthAverage: number | undefined;
    monthPrior: number | undefined;
    secondMonthPrior: number | undefined;
    thirdMonthPrior: number | undefined;
    varianceAmount: number;
    variancePercent: number;
}

export class CommissionDueOutput implements ICommissionDueOutput {
    orderNumber: string | undefined;
    partnerManager: string | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    company: string | undefined;
    location: string | undefined;
    product: string | undefined;
    mrr: number;
    orderDate: moment.Moment;
    provisionedDated: moment.Moment | undefined;

    constructor(data?: ICommissionDueOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['orderNumber'];
            this.partnerManager = _data['partnerManager'];
            this.partner = _data['partner'];
            this.salesAgent = _data['salesAgent'];
            this.company = _data['company'];
            this.location = _data['location'];
            this.product = _data['product'];
            this.mrr = _data['mrr'];
            this.orderDate = _data['orderDate'] ? moment(_data['orderDate'].toString()) : <any>undefined;
            this.provisionedDated = _data['provisionedDated'] ? moment(_data['provisionedDated'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CommissionDueOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionDueOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderNumber'] = this.orderNumber;
        data['partnerManager'] = this.partnerManager;
        data['partner'] = this.partner;
        data['salesAgent'] = this.salesAgent;
        data['company'] = this.company;
        data['location'] = this.location;
        data['product'] = this.product;
        data['mrr'] = this.mrr;
        data['orderDate'] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data['provisionedDated'] = this.provisionedDated ? this.provisionedDated.toISOString() : <any>undefined;
        return data;
    }

    clone(): CommissionDueOutput {
        const json = this.toJSON();
        let result = new CommissionDueOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionDueOutput {
    orderNumber: string | undefined;
    partnerManager: string | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    company: string | undefined;
    location: string | undefined;
    product: string | undefined;
    mrr: number;
    orderDate: moment.Moment;
    provisionedDated: moment.Moment | undefined;
}

export class CommissionField implements ICommissionField {
    name: string | undefined;
    isRequired: boolean;
    uploaderType: UploaderType;

    constructor(data?: ICommissionField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isRequired = _data['isRequired'];
            this.uploaderType = _data['uploaderType'];
        }
    }

    static fromJS(data: any): CommissionField {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isRequired'] = this.isRequired;
        data['uploaderType'] = this.uploaderType;
        return data;
    }

    clone(): CommissionField {
        const json = this.toJSON();
        let result = new CommissionField();
        result.init(json);
        return result;
    }
}

export interface ICommissionField {
    name: string | undefined;
    isRequired: boolean;
    uploaderType: UploaderType;
}

export class CommissionForecastOutput implements ICommissionForecastOutput {
    forecastType: string | undefined;
    monthOne: number;
    monthTwo: number;
    monthThree: number;
    monthFour: number;
    monthFive: number;
    monthSix: number;
    monthSeven: number;
    monthEight: number;
    monthNine: number;
    monthTen: number;
    monthEleven: number;
    monthTwelve: number;

    constructor(data?: ICommissionForecastOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forecastType = _data['forecastType'];
            this.monthOne = _data['monthOne'];
            this.monthTwo = _data['monthTwo'];
            this.monthThree = _data['monthThree'];
            this.monthFour = _data['monthFour'];
            this.monthFive = _data['monthFive'];
            this.monthSix = _data['monthSix'];
            this.monthSeven = _data['monthSeven'];
            this.monthEight = _data['monthEight'];
            this.monthNine = _data['monthNine'];
            this.monthTen = _data['monthTen'];
            this.monthEleven = _data['monthEleven'];
            this.monthTwelve = _data['monthTwelve'];
        }
    }

    static fromJS(data: any): CommissionForecastOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionForecastOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['forecastType'] = this.forecastType;
        data['monthOne'] = this.monthOne;
        data['monthTwo'] = this.monthTwo;
        data['monthThree'] = this.monthThree;
        data['monthFour'] = this.monthFour;
        data['monthFive'] = this.monthFive;
        data['monthSix'] = this.monthSix;
        data['monthSeven'] = this.monthSeven;
        data['monthEight'] = this.monthEight;
        data['monthNine'] = this.monthNine;
        data['monthTen'] = this.monthTen;
        data['monthEleven'] = this.monthEleven;
        data['monthTwelve'] = this.monthTwelve;
        return data;
    }

    clone(): CommissionForecastOutput {
        const json = this.toJSON();
        let result = new CommissionForecastOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionForecastOutput {
    forecastType: string | undefined;
    monthOne: number;
    monthTwo: number;
    monthThree: number;
    monthFour: number;
    monthFive: number;
    monthSix: number;
    monthSeven: number;
    monthEight: number;
    monthNine: number;
    monthTen: number;
    monthEleven: number;
    monthTwelve: number;
}

export class CommissionHistoryReportOutput implements ICommissionHistoryReportOutput {
    id: number;
    month: number;
    year: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountName: string | undefined;
    billingAccountNumber: string | undefined;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportName: string | undefined;
    revenueMonthYear: string | undefined;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    reference: string | undefined;
    productName: string | undefined;
    note: string | undefined;
    providerRevenue: number;
    partnerSubAgencyPercent: number;
    partnerSubAgencyCommission: number;
    partnerMargin: number;
    templateName: string | undefined;
    commissionTrackingTypeIds: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    ticketId: number | undefined;
    partnerOrderNumber: string | undefined;
    isAdjustment: boolean;
    appSmartMRGMV: number;

    constructor(data?: ICommissionHistoryReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.salesAgentName = _data['salesAgentName'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.billingAccountName = _data['billingAccountName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.partnerAcquisitionName = _data['partnerAcquisitionName'];
            this.partnerSubAgencyName = _data['partnerSubAgencyName'];
            this.partnerSalesSupportName = _data['partnerSalesSupportName'];
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.salesAgentCommissionPercent = _data['salesAgentCommissionPercent'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentCommissionPercentOfProviderRevenue = _data['salesAgentCommissionPercentOfProviderRevenue'];
            this.reference = _data['reference'];
            this.productName = _data['productName'];
            this.note = _data['note'];
            this.providerRevenue = _data['providerRevenue'];
            this.partnerSubAgencyPercent = _data['partnerSubAgencyPercent'];
            this.partnerSubAgencyCommission = _data['partnerSubAgencyCommission'];
            this.partnerMargin = _data['partnerMargin'];
            this.templateName = _data['templateName'];
            this.commissionTrackingTypeIds = _data['commissionTrackingTypeIds'];
            this.commissionTrackingTypeNames = _data['commissionTrackingTypeNames'];
            this.ticketId = _data['ticketId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.isAdjustment = _data['isAdjustment'];
            this.appSmartMRGMV = _data['appSmartMRGMV'];
        }
    }

    static fromJS(data: any): CommissionHistoryReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionHistoryReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['month'] = this.month;
        data['year'] = this.year;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['salesAgentName'] = this.salesAgentName;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['billingAccountName'] = this.billingAccountName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['partnerAcquisitionName'] = this.partnerAcquisitionName;
        data['partnerSubAgencyName'] = this.partnerSubAgencyName;
        data['partnerSalesSupportName'] = this.partnerSalesSupportName;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['salesAgentCommissionPercent'] = this.salesAgentCommissionPercent;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentCommissionPercentOfProviderRevenue'] = this.salesAgentCommissionPercentOfProviderRevenue;
        data['reference'] = this.reference;
        data['productName'] = this.productName;
        data['note'] = this.note;
        data['providerRevenue'] = this.providerRevenue;
        data['partnerSubAgencyPercent'] = this.partnerSubAgencyPercent;
        data['partnerSubAgencyCommission'] = this.partnerSubAgencyCommission;
        data['partnerMargin'] = this.partnerMargin;
        data['templateName'] = this.templateName;
        data['commissionTrackingTypeIds'] = this.commissionTrackingTypeIds;
        data['commissionTrackingTypeNames'] = this.commissionTrackingTypeNames;
        data['ticketId'] = this.ticketId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['isAdjustment'] = this.isAdjustment;
        data['appSmartMRGMV'] = this.appSmartMRGMV;
        return data;
    }

    clone(): CommissionHistoryReportOutput {
        const json = this.toJSON();
        let result = new CommissionHistoryReportOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionHistoryReportOutput {
    id: number;
    month: number;
    year: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountName: string | undefined;
    billingAccountNumber: string | undefined;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportName: string | undefined;
    revenueMonthYear: string | undefined;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    reference: string | undefined;
    productName: string | undefined;
    note: string | undefined;
    providerRevenue: number;
    partnerSubAgencyPercent: number;
    partnerSubAgencyCommission: number;
    partnerMargin: number;
    templateName: string | undefined;
    commissionTrackingTypeIds: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    ticketId: number | undefined;
    partnerOrderNumber: string | undefined;
    isAdjustment: boolean;
    appSmartMRGMV: number;
}

export class CommissionOrderVarianceDto implements ICommissionOrderVarianceDto {
    month: number;
    year: number;
    orderNumber: string | undefined;
    customerId: number;
    customerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string | undefined;
    mrr: number;
    providerRevenue: number;

    constructor(data?: ICommissionOrderVarianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.orderNumber = _data['orderNumber'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.mrr = _data['mrr'];
            this.providerRevenue = _data['providerRevenue'];
        }
    }

    static fromJS(data: any): CommissionOrderVarianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionOrderVarianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['orderNumber'] = this.orderNumber;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['mrr'] = this.mrr;
        data['providerRevenue'] = this.providerRevenue;
        return data;
    }

    clone(): CommissionOrderVarianceDto {
        const json = this.toJSON();
        let result = new CommissionOrderVarianceDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionOrderVarianceDto {
    month: number;
    year: number;
    orderNumber: string | undefined;
    customerId: number;
    customerName: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountNumber: string | undefined;
    mrr: number;
    providerRevenue: number;
}

export class CommissionProviderImportDto implements ICommissionProviderImportDto {
    invalidColumnList: string[] | undefined;
    invalidFlag: boolean;
    importResult: ImportUploadOutput;

    constructor(data?: ICommissionProviderImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['invalidColumnList'])) {
                this.invalidColumnList = [] as any;
                for (let item of _data['invalidColumnList']) this.invalidColumnList.push(item);
            }
            this.invalidFlag = _data['invalidFlag'];
            this.importResult = _data['importResult'] ? ImportUploadOutput.fromJS(_data['importResult']) : <any>undefined;
        }
    }

    static fromJS(data: any): CommissionProviderImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionProviderImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invalidColumnList)) {
            data['invalidColumnList'] = [];
            for (let item of this.invalidColumnList) data['invalidColumnList'].push(item);
        }
        data['invalidFlag'] = this.invalidFlag;
        data['importResult'] = this.importResult ? this.importResult.toJSON() : <any>undefined;
        return data;
    }

    clone(): CommissionProviderImportDto {
        const json = this.toJSON();
        let result = new CommissionProviderImportDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionProviderImportDto {
    invalidColumnList: string[] | undefined;
    invalidFlag: boolean;
    importResult: ImportUploadOutput;
}

export class CommissionProviderImportSummaryDto implements ICommissionProviderImportSummaryDto {
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    productName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerNRRCommission: number | undefined;
    reference: string | undefined;
    note: string | undefined;
    errorMessage: string | undefined;
    id: number;

    constructor(data?: ICommissionProviderImportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.productName = _data['productName'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcCommissionPercent = _data['mcCommissionPercent'];
            this.mcmrrCommission = _data['mcmrrCommission'];
            this.partnerNRRCommission = _data['partnerNRRCommission'];
            this.reference = _data['reference'];
            this.note = _data['note'];
            this.errorMessage = _data['errorMessage'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionProviderImportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionProviderImportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['productName'] = this.productName;
        data['providerRevenue'] = this.providerRevenue;
        data['mcCommissionPercent'] = this.mcCommissionPercent;
        data['mcmrrCommission'] = this.mcmrrCommission;
        data['partnerNRRCommission'] = this.partnerNRRCommission;
        data['reference'] = this.reference;
        data['note'] = this.note;
        data['errorMessage'] = this.errorMessage;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionProviderImportSummaryDto {
        const json = this.toJSON();
        let result = new CommissionProviderImportSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionProviderImportSummaryDto {
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    productName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerNRRCommission: number | undefined;
    reference: string | undefined;
    note: string | undefined;
    errorMessage: string | undefined;
    id: number;
}

export class CommissionProviderImportSummaryDtoPagedResultDto implements ICommissionProviderImportSummaryDtoPagedResultDto {
    totalCount: number;
    items: CommissionProviderImportSummaryDto[] | undefined;

    constructor(data?: ICommissionProviderImportSummaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CommissionProviderImportSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionProviderImportSummaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionProviderImportSummaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CommissionProviderImportSummaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommissionProviderImportSummaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionProviderImportSummaryDtoPagedResultDto {
    totalCount: number;
    items: CommissionProviderImportSummaryDto[] | undefined;
}

export class CommissionReceivableEditDto implements ICommissionReceivableEditDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    receivedMonth: number;
    receivedYear: number;
    applyMonth: number;
    applyYear: number;
    checkAmount: number;
    commissionTemplateId: number | undefined;
    id: number;

    constructor(data?: ICommissionReceivableEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.receivedMonth = _data['receivedMonth'];
            this.receivedYear = _data['receivedYear'];
            this.applyMonth = _data['applyMonth'];
            this.applyYear = _data['applyYear'];
            this.checkAmount = _data['checkAmount'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionReceivableEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReceivableEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['receivedMonth'] = this.receivedMonth;
        data['receivedYear'] = this.receivedYear;
        data['applyMonth'] = this.applyMonth;
        data['applyYear'] = this.applyYear;
        data['checkAmount'] = this.checkAmount;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionReceivableEditDto {
        const json = this.toJSON();
        let result = new CommissionReceivableEditDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReceivableEditDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    receivedMonth: number;
    receivedYear: number;
    applyMonth: number;
    applyYear: number;
    checkAmount: number;
    commissionTemplateId: number | undefined;
    id: number;
}

export class CommissionReceivableListDto implements ICommissionReceivableListDto {
    id: number;
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    receivedMonth: number;
    receivedYear: number;
    applyMonth: number;
    applyYear: number;
    checkAmount: number;
    uploadAmount: number;
    differnceAmount: number;
    reviewed: boolean;
    commissionTemplateId: number | undefined;
    commissionTemplateName: string | undefined;

    constructor(data?: ICommissionReceivableListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.receivedMonth = _data['receivedMonth'];
            this.receivedYear = _data['receivedYear'];
            this.applyMonth = _data['applyMonth'];
            this.applyYear = _data['applyYear'];
            this.checkAmount = _data['checkAmount'];
            this.uploadAmount = _data['uploadAmount'];
            this.differnceAmount = _data['differnceAmount'];
            this.reviewed = _data['reviewed'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.commissionTemplateName = _data['commissionTemplateName'];
        }
    }

    static fromJS(data: any): CommissionReceivableListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReceivableListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['receivedMonth'] = this.receivedMonth;
        data['receivedYear'] = this.receivedYear;
        data['applyMonth'] = this.applyMonth;
        data['applyYear'] = this.applyYear;
        data['checkAmount'] = this.checkAmount;
        data['uploadAmount'] = this.uploadAmount;
        data['differnceAmount'] = this.differnceAmount;
        data['reviewed'] = this.reviewed;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['commissionTemplateName'] = this.commissionTemplateName;
        return data;
    }

    clone(): CommissionReceivableListDto {
        const json = this.toJSON();
        let result = new CommissionReceivableListDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReceivableListDto {
    id: number;
    tenantId: number | undefined;
    providerId: number;
    providerName: string | undefined;
    receivedMonth: number;
    receivedYear: number;
    applyMonth: number;
    applyYear: number;
    checkAmount: number;
    uploadAmount: number;
    differnceAmount: number;
    reviewed: boolean;
    commissionTemplateId: number | undefined;
    commissionTemplateName: string | undefined;
}

export class CommissionReceivableListDtoPagedResultDto implements ICommissionReceivableListDtoPagedResultDto {
    totalCount: number;
    items: CommissionReceivableListDto[] | undefined;

    constructor(data?: ICommissionReceivableListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CommissionReceivableListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionReceivableListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReceivableListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CommissionReceivableListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommissionReceivableListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReceivableListDtoPagedResultDto {
    totalCount: number;
    items: CommissionReceivableListDto[] | undefined;
}

export class CommissionReceivableReviewInputEditDto implements ICommissionReceivableReviewInputEditDto {
    providerId: number;
    month: number;
    year: number;
    isReview: boolean;
    commissionTemplateId: number | undefined;

    constructor(data?: ICommissionReceivableReviewInputEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.isReview = _data['isReview'];
            this.commissionTemplateId = _data['commissionTemplateId'];
        }
    }

    static fromJS(data: any): CommissionReceivableReviewInputEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReceivableReviewInputEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['isReview'] = this.isReview;
        data['commissionTemplateId'] = this.commissionTemplateId;
        return data;
    }

    clone(): CommissionReceivableReviewInputEditDto {
        const json = this.toJSON();
        let result = new CommissionReceivableReviewInputEditDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReceivableReviewInputEditDto {
    providerId: number;
    month: number;
    year: number;
    isReview: boolean;
    commissionTemplateId: number | undefined;
}

export class CommissionReviewDto implements ICommissionReviewDto {
    id: number;
    commissionWorkbookDetailId: number;
    month: number;
    year: number;
    cycle: moment.Moment;
    revenueMonthYear: string | undefined;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    marginAfterSale: number;
    strategicPartnerManager: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    isAdjustment: boolean;
    commissionProviderImportId: number | undefined;
    partnerOrderNumber: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    creationTime: moment.Moment;
    onHold: boolean;
    adjustmentScheduleIdHoldRelease: number | undefined;
    masterAgencyId: number | undefined;
    masterAgencyName: string | undefined;

    constructor(data?: ICommissionReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.commissionWorkbookDetailId = _data['commissionWorkbookDetailId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.cycle = _data['cycle'] ? moment(_data['cycle'].toString()) : <any>undefined;
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.productName = _data['productName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcCommissionPercent = _data['mcCommissionPercent'];
            this.mcmrrCommission = _data['mcmrrCommission'];
            this.partnerCommissionPercent = _data['partnerCommissionPercent'];
            this.salesAgentName = _data['salesAgentName'];
            this.salesAgentSplitRate = _data['salesAgentSplitRate'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.salesAgentCommissionPercent = _data['salesAgentCommissionPercent'];
            this.marginAfterSale = _data['marginAfterSale'];
            this.strategicPartnerManager = _data['strategicPartnerManager'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.reference = _data['reference'];
            this.note = _data['note'];
            this.isAdjustment = _data['isAdjustment'];
            this.commissionProviderImportId = _data['commissionProviderImportId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.commissionTrackingTypeNames = _data['commissionTrackingTypeNames'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.onHold = _data['onHold'];
            this.adjustmentScheduleIdHoldRelease = _data['adjustmentScheduleIdHoldRelease'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.masterAgencyName = _data['masterAgencyName'];
        }
    }

    static fromJS(data: any): CommissionReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['commissionWorkbookDetailId'] = this.commissionWorkbookDetailId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['cycle'] = this.cycle ? this.cycle.toISOString() : <any>undefined;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['productName'] = this.productName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['providerRevenue'] = this.providerRevenue;
        data['mcCommissionPercent'] = this.mcCommissionPercent;
        data['mcmrrCommission'] = this.mcmrrCommission;
        data['partnerCommissionPercent'] = this.partnerCommissionPercent;
        data['salesAgentName'] = this.salesAgentName;
        data['salesAgentSplitRate'] = this.salesAgentSplitRate;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['salesAgentCommissionPercent'] = this.salesAgentCommissionPercent;
        data['marginAfterSale'] = this.marginAfterSale;
        data['strategicPartnerManager'] = this.strategicPartnerManager;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['reference'] = this.reference;
        data['note'] = this.note;
        data['isAdjustment'] = this.isAdjustment;
        data['commissionProviderImportId'] = this.commissionProviderImportId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['commissionTrackingTypeNames'] = this.commissionTrackingTypeNames;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['onHold'] = this.onHold;
        data['adjustmentScheduleIdHoldRelease'] = this.adjustmentScheduleIdHoldRelease;
        data['masterAgencyId'] = this.masterAgencyId;
        data['masterAgencyName'] = this.masterAgencyName;
        return data;
    }

    clone(): CommissionReviewDto {
        const json = this.toJSON();
        let result = new CommissionReviewDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReviewDto {
    id: number;
    commissionWorkbookDetailId: number;
    month: number;
    year: number;
    cycle: moment.Moment;
    revenueMonthYear: string | undefined;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    marginAfterSale: number;
    strategicPartnerManager: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    isAdjustment: boolean;
    commissionProviderImportId: number | undefined;
    partnerOrderNumber: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    creationTime: moment.Moment;
    onHold: boolean;
    adjustmentScheduleIdHoldRelease: number | undefined;
    masterAgencyId: number | undefined;
    masterAgencyName: string | undefined;
}

export class CommissionReviewDtoPagedResultDto implements ICommissionReviewDtoPagedResultDto {
    totalCount: number;
    items: CommissionReviewDto[] | undefined;

    constructor(data?: ICommissionReviewDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CommissionReviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionReviewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReviewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): CommissionReviewDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommissionReviewDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionReviewDtoPagedResultDto {
    totalCount: number;
    items: CommissionReviewDto[] | undefined;
}

export class CommissionReviewFiltersInput implements ICommissionReviewFiltersInput {
    cycleStart: moment.Moment | undefined;
    cycleEnd: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    masterAgencyId: number | undefined;
    providerId: number | undefined;
    providerStatementId: number | undefined;
    advisorId: number | undefined;
    onlyHolds: boolean;

    constructor(data?: ICommissionReviewFiltersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cycleStart = _data['cycleStart'] ? moment(_data['cycleStart'].toString()) : <any>undefined;
            this.cycleEnd = _data['cycleEnd'] ? moment(_data['cycleEnd'].toString()) : <any>undefined;
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.providerId = _data['providerId'];
            this.providerStatementId = _data['providerStatementId'];
            this.advisorId = _data['advisorId'];
            this.onlyHolds = _data['onlyHolds'];
        }
    }

    static fromJS(data: any): CommissionReviewFiltersInput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReviewFiltersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['cycleStart'] = this.cycleStart ? this.cycleStart.toISOString() : <any>undefined;
        data['cycleEnd'] = this.cycleEnd ? this.cycleEnd.toISOString() : <any>undefined;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['masterAgencyId'] = this.masterAgencyId;
        data['providerId'] = this.providerId;
        data['providerStatementId'] = this.providerStatementId;
        data['advisorId'] = this.advisorId;
        data['onlyHolds'] = this.onlyHolds;
        return data;
    }

    clone(): CommissionReviewFiltersInput {
        const json = this.toJSON();
        let result = new CommissionReviewFiltersInput();
        result.init(json);
        return result;
    }
}

export interface ICommissionReviewFiltersInput {
    cycleStart: moment.Moment | undefined;
    cycleEnd: moment.Moment | undefined;
    billingAccountNumber: string | undefined;
    masterAgencyId: number | undefined;
    providerId: number | undefined;
    providerStatementId: number | undefined;
    advisorId: number | undefined;
    onlyHolds: boolean;
}

export class CommissionReviewsCountsOutput implements ICommissionReviewsCountsOutput {
    commissionCount: number;
    exceptionCount: number;
    adjustmentCount: number;

    constructor(data?: ICommissionReviewsCountsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionCount = _data['commissionCount'];
            this.exceptionCount = _data['exceptionCount'];
            this.adjustmentCount = _data['adjustmentCount'];
        }
    }

    static fromJS(data: any): CommissionReviewsCountsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReviewsCountsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionCount'] = this.commissionCount;
        data['exceptionCount'] = this.exceptionCount;
        data['adjustmentCount'] = this.adjustmentCount;
        return data;
    }

    clone(): CommissionReviewsCountsOutput {
        const json = this.toJSON();
        let result = new CommissionReviewsCountsOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionReviewsCountsOutput {
    commissionCount: number;
    exceptionCount: number;
    adjustmentCount: number;
}

export class CommissionReviewsSummaryOutput implements ICommissionReviewsSummaryOutput {
    commissionTrackingTypeId: number | undefined;
    commissionTrackingTypeName: string | undefined;
    totalItems: number;
    providerRevenue: number;
    mcMRRCommission: number;
    salesAgentMRRCommission: number;
    salesAgentNRRCommission: number;
    marginAfterSale: number;

    constructor(data?: ICommissionReviewsSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionTrackingTypeId = _data['commissionTrackingTypeId'];
            this.commissionTrackingTypeName = _data['commissionTrackingTypeName'];
            this.totalItems = _data['totalItems'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcMRRCommission = _data['mcMRRCommission'];
            this.salesAgentMRRCommission = _data['salesAgentMRRCommission'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.marginAfterSale = _data['marginAfterSale'];
        }
    }

    static fromJS(data: any): CommissionReviewsSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionReviewsSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionTrackingTypeId'] = this.commissionTrackingTypeId;
        data['commissionTrackingTypeName'] = this.commissionTrackingTypeName;
        data['totalItems'] = this.totalItems;
        data['providerRevenue'] = this.providerRevenue;
        data['mcMRRCommission'] = this.mcMRRCommission;
        data['salesAgentMRRCommission'] = this.salesAgentMRRCommission;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['marginAfterSale'] = this.marginAfterSale;
        return data;
    }

    clone(): CommissionReviewsSummaryOutput {
        const json = this.toJSON();
        let result = new CommissionReviewsSummaryOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionReviewsSummaryOutput {
    commissionTrackingTypeId: number | undefined;
    commissionTrackingTypeName: string | undefined;
    totalItems: number;
    providerRevenue: number;
    mcMRRCommission: number;
    salesAgentMRRCommission: number;
    salesAgentNRRCommission: number;
    marginAfterSale: number;
}

export class CommissionTotalPreviewOutput implements ICommissionTotalPreviewOutput {
    providerRevenue: number;
    mcMRRCommission: number;
    salesAgentMRRCommission: number;
    salesAgentNRRCommission: number;
    marginAfterSale: number;

    constructor(data?: ICommissionTotalPreviewOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerRevenue = _data['providerRevenue'];
            this.mcMRRCommission = _data['mcMRRCommission'];
            this.salesAgentMRRCommission = _data['salesAgentMRRCommission'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.marginAfterSale = _data['marginAfterSale'];
        }
    }

    static fromJS(data: any): CommissionTotalPreviewOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTotalPreviewOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerRevenue'] = this.providerRevenue;
        data['mcMRRCommission'] = this.mcMRRCommission;
        data['salesAgentMRRCommission'] = this.salesAgentMRRCommission;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['marginAfterSale'] = this.marginAfterSale;
        return data;
    }

    clone(): CommissionTotalPreviewOutput {
        const json = this.toJSON();
        let result = new CommissionTotalPreviewOutput();
        result.init(json);
        return result;
    }
}

export interface ICommissionTotalPreviewOutput {
    providerRevenue: number;
    mcMRRCommission: number;
    salesAgentMRRCommission: number;
    salesAgentNRRCommission: number;
    marginAfterSale: number;
}

export class CommissionTrackingDto implements ICommissionTrackingDto {
    trackingId: number;
    trackingName: string | undefined;
    trackingTypeId: number;
    commissionWorkbookId: number;

    constructor(data?: ICommissionTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackingId = _data['trackingId'];
            this.trackingName = _data['trackingName'];
            this.trackingTypeId = _data['trackingTypeId'];
            this.commissionWorkbookId = _data['commissionWorkbookId'];
        }
    }

    static fromJS(data: any): CommissionTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['trackingId'] = this.trackingId;
        data['trackingName'] = this.trackingName;
        data['trackingTypeId'] = this.trackingTypeId;
        data['commissionWorkbookId'] = this.commissionWorkbookId;
        return data;
    }

    clone(): CommissionTrackingDto {
        const json = this.toJSON();
        let result = new CommissionTrackingDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionTrackingDto {
    trackingId: number;
    trackingName: string | undefined;
    trackingTypeId: number;
    commissionWorkbookId: number;
}

export class CommissionTrackingListDto implements ICommissionTrackingListDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICommissionTrackingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CommissionTrackingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionTrackingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): CommissionTrackingListDto {
        const json = this.toJSON();
        let result = new CommissionTrackingListDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionTrackingListDto {
    id: number;
    name: string | undefined;
}

export class CommissionUploaderInput implements ICommissionUploaderInput {
    month: number;
    year: number;
    partnerAcquisitionIds: string | undefined;
    uploaderType: ReportUploaderType;

    constructor(data?: ICommissionUploaderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.partnerAcquisitionIds = _data['partnerAcquisitionIds'];
            this.uploaderType = _data['uploaderType'];
        }
    }

    static fromJS(data: any): CommissionUploaderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionUploaderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['partnerAcquisitionIds'] = this.partnerAcquisitionIds;
        data['uploaderType'] = this.uploaderType;
        return data;
    }

    clone(): CommissionUploaderInput {
        const json = this.toJSON();
        let result = new CommissionUploaderInput();
        result.init(json);
        return result;
    }
}

export interface ICommissionUploaderInput {
    month: number;
    year: number;
    partnerAcquisitionIds: string | undefined;
    uploaderType: ReportUploaderType;
}

export class CommissionWorkbookDetailListDto implements ICommissionWorkbookDetailListDto {
    partnerId: number;
    partnerName: string | undefined;
    partnerAcquisitionId: number;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyId: number | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportId: number | undefined;
    partnerSalesSupportName: string | undefined;
    strategicPartnerManagerId: number;
    strategicPartnerManagerName: string | undefined;
    partnerManagerId: number;
    partnerManagerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    commissionWorkbookId: number;
    commissionWorkbook: CommissionWorkbookDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICommissionWorkbookDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.partnerAcquisitionName = _data['partnerAcquisitionName'];
            this.partnerSubAgencyId = _data['partnerSubAgencyId'];
            this.partnerSubAgencyName = _data['partnerSubAgencyName'];
            this.partnerSalesSupportId = _data['partnerSalesSupportId'];
            this.partnerSalesSupportName = _data['partnerSalesSupportName'];
            this.strategicPartnerManagerId = _data['strategicPartnerManagerId'];
            this.strategicPartnerManagerName = _data['strategicPartnerManagerName'];
            this.partnerManagerId = _data['partnerManagerId'];
            this.partnerManagerName = _data['partnerManagerName'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgentName = _data['salesAgentName'];
            this.salesAgentSplitRate = _data['salesAgentSplitRate'];
            this.salesAgentCommissionPercentOfProviderRevenue = _data['salesAgentCommissionPercentOfProviderRevenue'];
            this.salesAgentCommissionPercent = _data['salesAgentCommissionPercent'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.commissionWorkbookId = _data['commissionWorkbookId'];
            this.commissionWorkbook = _data['commissionWorkbook']
                ? CommissionWorkbookDto.fromJS(_data['commissionWorkbook'])
                : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionWorkbookDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionWorkbookDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['partnerAcquisitionName'] = this.partnerAcquisitionName;
        data['partnerSubAgencyId'] = this.partnerSubAgencyId;
        data['partnerSubAgencyName'] = this.partnerSubAgencyName;
        data['partnerSalesSupportId'] = this.partnerSalesSupportId;
        data['partnerSalesSupportName'] = this.partnerSalesSupportName;
        data['strategicPartnerManagerId'] = this.strategicPartnerManagerId;
        data['strategicPartnerManagerName'] = this.strategicPartnerManagerName;
        data['partnerManagerId'] = this.partnerManagerId;
        data['partnerManagerName'] = this.partnerManagerName;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgentName'] = this.salesAgentName;
        data['salesAgentSplitRate'] = this.salesAgentSplitRate;
        data['salesAgentCommissionPercentOfProviderRevenue'] = this.salesAgentCommissionPercentOfProviderRevenue;
        data['salesAgentCommissionPercent'] = this.salesAgentCommissionPercent;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['commissionWorkbookId'] = this.commissionWorkbookId;
        data['commissionWorkbook'] = this.commissionWorkbook ? this.commissionWorkbook.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionWorkbookDetailListDto {
        const json = this.toJSON();
        let result = new CommissionWorkbookDetailListDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionWorkbookDetailListDto {
    partnerId: number;
    partnerName: string | undefined;
    partnerAcquisitionId: number;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyId: number | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportId: number | undefined;
    partnerSalesSupportName: string | undefined;
    strategicPartnerManagerId: number;
    strategicPartnerManagerName: string | undefined;
    partnerManagerId: number;
    partnerManagerName: string | undefined;
    salesAgentId: number;
    salesAgentName: string | undefined;
    salesAgentSplitRate: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentNRRCommission: number;
    commissionWorkbookId: number;
    commissionWorkbook: CommissionWorkbookDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CommissionWorkbookDto implements ICommissionWorkbookDto {
    tenantId: number | undefined;
    month: number;
    year: number;
    providerId: number;
    providerName: string;
    productName: string;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    billingAccountNumber: string;
    billingAccountName: string;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    marginAfterSale: number;
    isAdjustment: boolean;

    constructor(data?: ICommissionWorkbookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.productName = _data['productName'];
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.reference = _data['reference'];
            this.note = _data['note'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcCommissionPercent = _data['mcCommissionPercent'];
            this.mcmrrCommission = _data['mcmrrCommission'];
            this.partnerCommissionPercent = _data['partnerCommissionPercent'];
            this.marginAfterSale = _data['marginAfterSale'];
            this.isAdjustment = _data['isAdjustment'];
        }
    }

    static fromJS(data: any): CommissionWorkbookDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionWorkbookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['productName'] = this.productName;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['reference'] = this.reference;
        data['note'] = this.note;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['providerRevenue'] = this.providerRevenue;
        data['mcCommissionPercent'] = this.mcCommissionPercent;
        data['mcmrrCommission'] = this.mcmrrCommission;
        data['partnerCommissionPercent'] = this.partnerCommissionPercent;
        data['marginAfterSale'] = this.marginAfterSale;
        data['isAdjustment'] = this.isAdjustment;
        return data;
    }

    clone(): CommissionWorkbookDto {
        const json = this.toJSON();
        let result = new CommissionWorkbookDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionWorkbookDto {
    tenantId: number | undefined;
    month: number;
    year: number;
    providerId: number;
    providerName: string;
    productName: string;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    billingAccountNumber: string;
    billingAccountName: string;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    marginAfterSale: number;
    isAdjustment: boolean;
}

export class CommissionWorkbookListDto implements ICommissionWorkbookListDto {
    month: number;
    year: number;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    isAdjustment: boolean;
    commissionProviderImportId: number | undefined;
    partnerOrderNumber: string | undefined;
    commissionWorkbookDetails: CommissionWorkbookDetailListDto[] | undefined;
    commissionTrackingList: CommissionTrackingDto[] | undefined;
    marginAfterSale: number;
    id: number;

    constructor(data?: ICommissionWorkbookListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.productName = _data['productName'];
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.reference = _data['reference'];
            this.note = _data['note'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.providerRevenue = _data['providerRevenue'];
            this.mcCommissionPercent = _data['mcCommissionPercent'];
            this.mcmrrCommission = _data['mcmrrCommission'];
            this.partnerCommissionPercent = _data['partnerCommissionPercent'];
            this.isAdjustment = _data['isAdjustment'];
            this.commissionProviderImportId = _data['commissionProviderImportId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            if (Array.isArray(_data['commissionWorkbookDetails'])) {
                this.commissionWorkbookDetails = [] as any;
                for (let item of _data['commissionWorkbookDetails'])
                    this.commissionWorkbookDetails.push(CommissionWorkbookDetailListDto.fromJS(item));
            }
            if (Array.isArray(_data['commissionTrackingList'])) {
                this.commissionTrackingList = [] as any;
                for (let item of _data['commissionTrackingList']) this.commissionTrackingList.push(CommissionTrackingDto.fromJS(item));
            }
            this.marginAfterSale = _data['marginAfterSale'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): CommissionWorkbookListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionWorkbookListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['productName'] = this.productName;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['reference'] = this.reference;
        data['note'] = this.note;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['providerRevenue'] = this.providerRevenue;
        data['mcCommissionPercent'] = this.mcCommissionPercent;
        data['mcmrrCommission'] = this.mcmrrCommission;
        data['partnerCommissionPercent'] = this.partnerCommissionPercent;
        data['isAdjustment'] = this.isAdjustment;
        data['commissionProviderImportId'] = this.commissionProviderImportId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        if (Array.isArray(this.commissionWorkbookDetails)) {
            data['commissionWorkbookDetails'] = [];
            for (let item of this.commissionWorkbookDetails) data['commissionWorkbookDetails'].push(item.toJSON());
        }
        if (Array.isArray(this.commissionTrackingList)) {
            data['commissionTrackingList'] = [];
            for (let item of this.commissionTrackingList) data['commissionTrackingList'].push(item.toJSON());
        }
        data['marginAfterSale'] = this.marginAfterSale;
        data['id'] = this.id;
        return data;
    }

    clone(): CommissionWorkbookListDto {
        const json = this.toJSON();
        let result = new CommissionWorkbookListDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionWorkbookListDto {
    month: number;
    year: number;
    providerId: number;
    providerName: string | undefined;
    productName: string | undefined;
    revenueMonthYear: string | undefined;
    reference: string | undefined;
    note: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    providerRevenue: number;
    mcCommissionPercent: number;
    mcmrrCommission: number;
    partnerCommissionPercent: number;
    isAdjustment: boolean;
    commissionProviderImportId: number | undefined;
    partnerOrderNumber: string | undefined;
    commissionWorkbookDetails: CommissionWorkbookDetailListDto[] | undefined;
    commissionTrackingList: CommissionTrackingDto[] | undefined;
    marginAfterSale: number;
    id: number;
}

export class CreateCommissionHoldDto implements ICreateCommissionHoldDto {
    month: number;
    year: number;
    adjustmentScheduleItemId: number;
    commissionWorkbookDetailId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    description: string | undefined;
    monthlyAmount: number;
    adjustmentScheduleType: ScheduleTypeEnum;

    constructor(data?: ICreateCommissionHoldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.adjustmentScheduleItemId = _data['adjustmentScheduleItemId'];
            this.commissionWorkbookDetailId = _data['commissionWorkbookDetailId'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.monthlyAmount = _data['monthlyAmount'];
            this.adjustmentScheduleType = _data['adjustmentScheduleType'];
        }
    }

    static fromJS(data: any): CreateCommissionHoldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommissionHoldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['adjustmentScheduleItemId'] = this.adjustmentScheduleItemId;
        data['commissionWorkbookDetailId'] = this.commissionWorkbookDetailId;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['monthlyAmount'] = this.monthlyAmount;
        data['adjustmentScheduleType'] = this.adjustmentScheduleType;
        return data;
    }

    clone(): CreateCommissionHoldDto {
        const json = this.toJSON();
        let result = new CreateCommissionHoldDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCommissionHoldDto {
    month: number;
    year: number;
    adjustmentScheduleItemId: number;
    commissionWorkbookDetailId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    description: string | undefined;
    monthlyAmount: number;
    adjustmentScheduleType: ScheduleTypeEnum;
}

export class CreateDeleteCommissionTrackingInput implements ICreateDeleteCommissionTrackingInput {
    workbookId: number;
    commissionTrackingTypeIds: number[] | undefined;

    constructor(data?: ICreateDeleteCommissionTrackingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookId = _data['workbookId'];
            if (Array.isArray(_data['commissionTrackingTypeIds'])) {
                this.commissionTrackingTypeIds = [] as any;
                for (let item of _data['commissionTrackingTypeIds']) this.commissionTrackingTypeIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDeleteCommissionTrackingInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeleteCommissionTrackingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['workbookId'] = this.workbookId;
        if (Array.isArray(this.commissionTrackingTypeIds)) {
            data['commissionTrackingTypeIds'] = [];
            for (let item of this.commissionTrackingTypeIds) data['commissionTrackingTypeIds'].push(item);
        }
        return data;
    }

    clone(): CreateDeleteCommissionTrackingInput {
        const json = this.toJSON();
        let result = new CreateDeleteCommissionTrackingInput();
        result.init(json);
        return result;
    }
}

export interface ICreateDeleteCommissionTrackingInput {
    workbookId: number;
    commissionTrackingTypeIds: number[] | undefined;
}

export class CreateOrUpdateCommissionReceivableInput implements ICreateOrUpdateCommissionReceivableInput {
    commissionReceivable: CommissionReceivableEditDto;

    constructor(data?: ICreateOrUpdateCommissionReceivableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionReceivable = _data['commissionReceivable']
                ? CommissionReceivableEditDto.fromJS(_data['commissionReceivable'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateCommissionReceivableInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCommissionReceivableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionReceivable'] = this.commissionReceivable ? this.commissionReceivable.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateCommissionReceivableInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateCommissionReceivableInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCommissionReceivableInput {
    commissionReceivable: CommissionReceivableEditDto;
}

export class CreateOrUpdateProviderTemplateInput implements ICreateOrUpdateProviderTemplateInput {
    providerImport: ProviderTemplateEditDto;
    templateDetail: TemplateDetailEditDto[] | undefined;

    constructor(data?: ICreateOrUpdateProviderTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerImport = _data['providerImport'] ? ProviderTemplateEditDto.fromJS(_data['providerImport']) : <any>undefined;
            if (Array.isArray(_data['templateDetail'])) {
                this.templateDetail = [] as any;
                for (let item of _data['templateDetail']) this.templateDetail.push(TemplateDetailEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateProviderTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProviderTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerImport'] = this.providerImport ? this.providerImport.toJSON() : <any>undefined;
        if (Array.isArray(this.templateDetail)) {
            data['templateDetail'] = [];
            for (let item of this.templateDetail) data['templateDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateProviderTemplateInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateProviderTemplateInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateProviderTemplateInput {
    providerImport: ProviderTemplateEditDto;
    templateDetail: TemplateDetailEditDto[] | undefined;
}

export class GetCalendarNoteInput implements IGetCalendarNoteInput {
    cid: number;
    note: string | undefined;

    constructor(data?: IGetCalendarNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cid = _data['cid'];
            this.note = _data['note'];
        }
    }

    static fromJS(data: any): GetCalendarNoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarNoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['cid'] = this.cid;
        data['note'] = this.note;
        return data;
    }

    clone(): GetCalendarNoteInput {
        const json = this.toJSON();
        let result = new GetCalendarNoteInput();
        result.init(json);
        return result;
    }
}

export interface IGetCalendarNoteInput {
    cid: number;
    note: string | undefined;
}

export class GetCommissionCalendarInput implements IGetCommissionCalendarInput {
    month: number;
    year: number;
    isMCRevenue: boolean;
    providerId: number | undefined;
    commissionManagerId: number | undefined;
    uploaderId: number | undefined;
    showOnlyStatementsWithAlerts: boolean | undefined;
    showOnlyStatementsWithUploadDate: boolean | undefined;
    maxResultCount: number;
    skipCount: number;

    constructor(data?: IGetCommissionCalendarInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.isMCRevenue = _data['isMCRevenue'];
            this.providerId = _data['providerId'];
            this.commissionManagerId = _data['commissionManagerId'];
            this.uploaderId = _data['uploaderId'];
            this.showOnlyStatementsWithAlerts = _data['showOnlyStatementsWithAlerts'];
            this.showOnlyStatementsWithUploadDate = _data['showOnlyStatementsWithUploadDate'];
            this.maxResultCount = _data['maxResultCount'];
            this.skipCount = _data['skipCount'];
        }
    }

    static fromJS(data: any): GetCommissionCalendarInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommissionCalendarInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['isMCRevenue'] = this.isMCRevenue;
        data['providerId'] = this.providerId;
        data['commissionManagerId'] = this.commissionManagerId;
        data['uploaderId'] = this.uploaderId;
        data['showOnlyStatementsWithAlerts'] = this.showOnlyStatementsWithAlerts;
        data['showOnlyStatementsWithUploadDate'] = this.showOnlyStatementsWithUploadDate;
        data['maxResultCount'] = this.maxResultCount;
        data['skipCount'] = this.skipCount;
        return data;
    }

    clone(): GetCommissionCalendarInput {
        const json = this.toJSON();
        let result = new GetCommissionCalendarInput();
        result.init(json);
        return result;
    }
}

export interface IGetCommissionCalendarInput {
    month: number;
    year: number;
    isMCRevenue: boolean;
    providerId: number | undefined;
    commissionManagerId: number | undefined;
    uploaderId: number | undefined;
    showOnlyStatementsWithAlerts: boolean | undefined;
    showOnlyStatementsWithUploadDate: boolean | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetCommissionReceivableForEditOutput implements IGetCommissionReceivableForEditOutput {
    comReceivable: CommissionReceivableEditDto;

    constructor(data?: IGetCommissionReceivableForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comReceivable = _data['comReceivable'] ? CommissionReceivableEditDto.fromJS(_data['comReceivable']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommissionReceivableForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommissionReceivableForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['comReceivable'] = this.comReceivable ? this.comReceivable.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCommissionReceivableForEditOutput {
        const json = this.toJSON();
        let result = new GetCommissionReceivableForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCommissionReceivableForEditOutput {
    comReceivable: CommissionReceivableEditDto;
}

export class GetProviderTemplateForEditOutput implements IGetProviderTemplateForEditOutput {
    providerTemplate: ProviderTemplateEditDto;
    templateDetail: TemplateDetailEditDto[] | undefined;

    constructor(data?: IGetProviderTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerTemplate = _data['providerTemplate'] ? ProviderTemplateEditDto.fromJS(_data['providerTemplate']) : <any>undefined;
            if (Array.isArray(_data['templateDetail'])) {
                this.templateDetail = [] as any;
                for (let item of _data['templateDetail']) this.templateDetail.push(TemplateDetailEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProviderTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerTemplate'] = this.providerTemplate ? this.providerTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.templateDetail)) {
            data['templateDetail'] = [];
            for (let item of this.templateDetail) data['templateDetail'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProviderTemplateForEditOutput {
        const json = this.toJSON();
        let result = new GetProviderTemplateForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProviderTemplateForEditOutput {
    providerTemplate: ProviderTemplateEditDto;
    templateDetail: TemplateDetailEditDto[] | undefined;
}

export class ImportUploadExceptionOutput implements IImportUploadExceptionOutput {
    rowData: { [key: string]: any } | undefined;
    exception: string | undefined;

    constructor(data?: IImportUploadExceptionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data['rowData']) {
                this.rowData = {} as any;
                for (let key in _data['rowData']) {
                    if (_data['rowData'].hasOwnProperty(key)) this.rowData[key] = _data['rowData'][key];
                }
            }
            this.exception = _data['exception'];
        }
    }

    static fromJS(data: any): ImportUploadExceptionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUploadExceptionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rowData) {
            data['rowData'] = {};
            for (let key in this.rowData) {
                if (this.rowData.hasOwnProperty(key)) data['rowData'][key] = this.rowData[key];
            }
        }
        data['exception'] = this.exception;
        return data;
    }

    clone(): ImportUploadExceptionOutput {
        const json = this.toJSON();
        let result = new ImportUploadExceptionOutput();
        result.init(json);
        return result;
    }
}

export interface IImportUploadExceptionOutput {
    rowData: { [key: string]: any } | undefined;
    exception: string | undefined;
}

export class ImportUploadOutput implements IImportUploadOutput {
    readonly dataCount: number;
    readonly successCount: number;
    readonly exceptions: ImportUploadExceptionOutput[] | undefined;

    constructor(data?: IImportUploadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dataCount = _data['dataCount'];
            (<any>this).successCount = _data['successCount'];
            if (Array.isArray(_data['exceptions'])) {
                (<any>this).exceptions = [] as any;
                for (let item of _data['exceptions']) (<any>this).exceptions.push(ImportUploadExceptionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportUploadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportUploadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['dataCount'] = this.dataCount;
        data['successCount'] = this.successCount;
        if (Array.isArray(this.exceptions)) {
            data['exceptions'] = [];
            for (let item of this.exceptions) data['exceptions'].push(item.toJSON());
        }
        return data;
    }

    clone(): ImportUploadOutput {
        const json = this.toJSON();
        let result = new ImportUploadOutput();
        result.init(json);
        return result;
    }
}

export interface IImportUploadOutput {
    dataCount: number;
    successCount: number;
    exceptions: ImportUploadExceptionOutput[] | undefined;
}

export interface IInt64IdNameDto {
    id: number;
    name: string | undefined;
}

export enum LogLevel {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum MonthStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class OuptutAccountingQuickbooks implements IOuptutAccountingQuickbooks {
    cust: string | undefined;
    reference: string | undefined;
    customerName: string | undefined;
    description: string | undefined;
    price: number;
    percentage: number;
    date: moment.Moment;
    accountNumber: string | undefined;

    constructor(data?: IOuptutAccountingQuickbooks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cust = _data['cust'];
            this.reference = _data['reference'];
            this.customerName = _data['customerName'];
            this.description = _data['description'];
            this.price = _data['price'];
            this.percentage = _data['percentage'];
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            this.accountNumber = _data['accountNumber'];
        }
    }

    static fromJS(data: any): OuptutAccountingQuickbooks {
        data = typeof data === 'object' ? data : {};
        let result = new OuptutAccountingQuickbooks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['cust'] = this.cust;
        data['reference'] = this.reference;
        data['customerName'] = this.customerName;
        data['description'] = this.description;
        data['price'] = this.price;
        data['percentage'] = this.percentage;
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        data['accountNumber'] = this.accountNumber;
        return data;
    }

    clone(): OuptutAccountingQuickbooks {
        const json = this.toJSON();
        let result = new OuptutAccountingQuickbooks();
        result.init(json);
        return result;
    }
}

export interface IOuptutAccountingQuickbooks {
    cust: string | undefined;
    reference: string | undefined;
    customerName: string | undefined;
    description: string | undefined;
    price: number;
    percentage: number;
    date: moment.Moment;
    accountNumber: string | undefined;
}

export class OuptutSPMDetailsDto implements IOuptutSPMDetailsDto {
    spmId: number;
    spmName: string | undefined;
    pmId: number;
    pmName: string | undefined;

    constructor(data?: IOuptutSPMDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spmId = _data['spmId'];
            this.spmName = _data['spmName'];
            this.pmId = _data['pmId'];
            this.pmName = _data['pmName'];
        }
    }

    static fromJS(data: any): OuptutSPMDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OuptutSPMDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['spmId'] = this.spmId;
        data['spmName'] = this.spmName;
        data['pmId'] = this.pmId;
        data['pmName'] = this.pmName;
        return data;
    }

    clone(): OuptutSPMDetailsDto {
        const json = this.toJSON();
        let result = new OuptutSPMDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IOuptutSPMDetailsDto {
    spmId: number;
    spmName: string | undefined;
    pmId: number;
    pmName: string | undefined;
}

export class OutputAccountinARInvoice implements IOutputAccountinARInvoice {
    mcnrrCommission: boolean;
    carrier: string | undefined;
    item: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    rate: number;
    class: string | undefined;
    amount: number;
    reference: string | undefined;

    constructor(data?: IOutputAccountinARInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mcnrrCommission = _data['mcnrrCommission'];
            this.carrier = _data['carrier'];
            this.item = _data['item'];
            this.description = _data['description'];
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            this.rate = _data['rate'];
            this.class = _data['class'];
            this.amount = _data['amount'];
            this.reference = _data['reference'];
        }
    }

    static fromJS(data: any): OutputAccountinARInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new OutputAccountinARInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['mcnrrCommission'] = this.mcnrrCommission;
        data['carrier'] = this.carrier;
        data['item'] = this.item;
        data['description'] = this.description;
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        data['rate'] = this.rate;
        data['class'] = this.class;
        data['amount'] = this.amount;
        data['reference'] = this.reference;
        return data;
    }

    clone(): OutputAccountinARInvoice {
        const json = this.toJSON();
        let result = new OutputAccountinARInvoice();
        result.init(json);
        return result;
    }
}

export interface IOutputAccountinARInvoice {
    mcnrrCommission: boolean;
    carrier: string | undefined;
    item: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    rate: number;
    class: string | undefined;
    amount: number;
    reference: string | undefined;
}

export class OutputAccountingAPVoucher implements IOutputAccountingAPVoucher {
    agency: string | undefined;
    item: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    rate: number;
    class: string | undefined;
    amount: number;
    reference: string | undefined;

    constructor(data?: IOutputAccountingAPVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data['agency'];
            this.item = _data['item'];
            this.description = _data['description'];
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            this.rate = _data['rate'];
            this.class = _data['class'];
            this.amount = _data['amount'];
            this.reference = _data['reference'];
        }
    }

    static fromJS(data: any): OutputAccountingAPVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new OutputAccountingAPVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['agency'] = this.agency;
        data['item'] = this.item;
        data['description'] = this.description;
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        data['rate'] = this.rate;
        data['class'] = this.class;
        data['amount'] = this.amount;
        data['reference'] = this.reference;
        return data;
    }

    clone(): OutputAccountingAPVoucher {
        const json = this.toJSON();
        let result = new OutputAccountingAPVoucher();
        result.init(json);
        return result;
    }
}

export interface IOutputAccountingAPVoucher {
    agency: string | undefined;
    item: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    rate: number;
    class: string | undefined;
    amount: number;
    reference: string | undefined;
}

export class OutputCommissionCheck implements IOutputCommissionCheck {
    month: number;
    year: number;
    partner: string | undefined;
    fullName: string | undefined;
    paymentType: string | undefined;
    commissionCurrentMonth: number;
    holdCommissionAmount: number;
    commissionFirstMonth: number;
    commissionSecondMonth: number;
    commissionThirdMonth: number;
    scheduleAdjustmentAmount: number;

    constructor(data?: IOutputCommissionCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.partner = _data['partner'];
            this.fullName = _data['fullName'];
            this.paymentType = _data['paymentType'];
            this.commissionCurrentMonth = _data['commissionCurrentMonth'];
            this.holdCommissionAmount = _data['holdCommissionAmount'];
            this.commissionFirstMonth = _data['commissionFirstMonth'];
            this.commissionSecondMonth = _data['commissionSecondMonth'];
            this.commissionThirdMonth = _data['commissionThirdMonth'];
            this.scheduleAdjustmentAmount = _data['scheduleAdjustmentAmount'];
        }
    }

    static fromJS(data: any): OutputCommissionCheck {
        data = typeof data === 'object' ? data : {};
        let result = new OutputCommissionCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['partner'] = this.partner;
        data['fullName'] = this.fullName;
        data['paymentType'] = this.paymentType;
        data['commissionCurrentMonth'] = this.commissionCurrentMonth;
        data['holdCommissionAmount'] = this.holdCommissionAmount;
        data['commissionFirstMonth'] = this.commissionFirstMonth;
        data['commissionSecondMonth'] = this.commissionSecondMonth;
        data['commissionThirdMonth'] = this.commissionThirdMonth;
        data['scheduleAdjustmentAmount'] = this.scheduleAdjustmentAmount;
        return data;
    }

    clone(): OutputCommissionCheck {
        const json = this.toJSON();
        let result = new OutputCommissionCheck();
        result.init(json);
        return result;
    }
}

export interface IOutputCommissionCheck {
    month: number;
    year: number;
    partner: string | undefined;
    fullName: string | undefined;
    paymentType: string | undefined;
    commissionCurrentMonth: number;
    holdCommissionAmount: number;
    commissionFirstMonth: number;
    commissionSecondMonth: number;
    commissionThirdMonth: number;
    scheduleAdjustmentAmount: number;
}

export class OutputCommissionLostNew implements IOutputCommissionLostNew {
    month: number;
    year: number;
    provider: string | undefined;
    customer: string | undefined;
    partner: string | undefined;
    billingAccountNumber: string | undefined;
    providerRevenue: number;
    agentCommissionAmount: number;
    margin: number;
    averageLostProviderRevenue: number;
    averageAgentCommissionAmount: number;
    averageMargin: number;
    partnerOrderNumber: string | undefined;

    constructor(data?: IOutputCommissionLostNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.provider = _data['provider'];
            this.customer = _data['customer'];
            this.partner = _data['partner'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.providerRevenue = _data['providerRevenue'];
            this.agentCommissionAmount = _data['agentCommissionAmount'];
            this.margin = _data['margin'];
            this.averageLostProviderRevenue = _data['averageLostProviderRevenue'];
            this.averageAgentCommissionAmount = _data['averageAgentCommissionAmount'];
            this.averageMargin = _data['averageMargin'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
        }
    }

    static fromJS(data: any): OutputCommissionLostNew {
        data = typeof data === 'object' ? data : {};
        let result = new OutputCommissionLostNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['provider'] = this.provider;
        data['customer'] = this.customer;
        data['partner'] = this.partner;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['providerRevenue'] = this.providerRevenue;
        data['agentCommissionAmount'] = this.agentCommissionAmount;
        data['margin'] = this.margin;
        data['averageLostProviderRevenue'] = this.averageLostProviderRevenue;
        data['averageAgentCommissionAmount'] = this.averageAgentCommissionAmount;
        data['averageMargin'] = this.averageMargin;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        return data;
    }

    clone(): OutputCommissionLostNew {
        const json = this.toJSON();
        let result = new OutputCommissionLostNew();
        result.init(json);
        return result;
    }
}

export interface IOutputCommissionLostNew {
    month: number;
    year: number;
    provider: string | undefined;
    customer: string | undefined;
    partner: string | undefined;
    billingAccountNumber: string | undefined;
    providerRevenue: number;
    agentCommissionAmount: number;
    margin: number;
    averageLostProviderRevenue: number;
    averageAgentCommissionAmount: number;
    averageMargin: number;
    partnerOrderNumber: string | undefined;
}

export class OutputCommissionSegmentationReport implements IOutputCommissionSegmentationReport {
    advisorName: string | undefined;
    apid: number | undefined;
    gmv: number | undefined;
    commissionIncome: number | undefined;
    commissionExpense: number | undefined;
    invest: string | undefined;

    constructor(data?: IOutputCommissionSegmentationReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advisorName = _data['advisorName'];
            this.apid = _data['apid'];
            this.gmv = _data['gmv'];
            this.commissionIncome = _data['commissionIncome'];
            this.commissionExpense = _data['commissionExpense'];
            this.invest = _data['invest'];
        }
    }

    static fromJS(data: any): OutputCommissionSegmentationReport {
        data = typeof data === 'object' ? data : {};
        let result = new OutputCommissionSegmentationReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['advisorName'] = this.advisorName;
        data['apid'] = this.apid;
        data['gmv'] = this.gmv;
        data['commissionIncome'] = this.commissionIncome;
        data['commissionExpense'] = this.commissionExpense;
        data['invest'] = this.invest;
        return data;
    }

    clone(): OutputCommissionSegmentationReport {
        const json = this.toJSON();
        let result = new OutputCommissionSegmentationReport();
        result.init(json);
        return result;
    }
}

export interface IOutputCommissionSegmentationReport {
    advisorName: string | undefined;
    apid: number | undefined;
    gmv: number | undefined;
    commissionIncome: number | undefined;
    commissionExpense: number | undefined;
    invest: string | undefined;
}

export class OutputPMSPMDetail implements IOutputPMSPMDetail {
    month: number;
    year: number;
    pmName: string | undefined;
    spmName: string | undefined;
    margin: number;
    nqar: number;

    constructor(data?: IOutputPMSPMDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.pmName = _data['pmName'];
            this.spmName = _data['spmName'];
            this.margin = _data['margin'];
            this.nqar = _data['nqar'];
        }
    }

    static fromJS(data: any): OutputPMSPMDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OutputPMSPMDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['pmName'] = this.pmName;
        data['spmName'] = this.spmName;
        data['margin'] = this.margin;
        data['nqar'] = this.nqar;
        return data;
    }

    clone(): OutputPMSPMDetail {
        const json = this.toJSON();
        let result = new OutputPMSPMDetail();
        result.init(json);
        return result;
    }
}

export interface IOutputPMSPMDetail {
    month: number;
    year: number;
    pmName: string | undefined;
    spmName: string | undefined;
    margin: number;
    nqar: number;
}

export class OutputReportDetailsBilling implements IOutputReportDetailsBilling {
    year: number;
    month: number;
    partnerId: number;
    partner: string | undefined;
    salesAgentId: number;
    salesAgent: string | undefined;
    spmId: number;
    spm: string | undefined;
    providerRevenue: number;
    providerId: number;
    provider: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    ioId: number;
    io: string | undefined;

    constructor(data?: IOutputReportDetailsBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data['year'];
            this.month = _data['month'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'];
            this.spmId = _data['spmId'];
            this.spm = _data['spm'];
            this.providerRevenue = _data['providerRevenue'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.ioId = _data['ioId'];
            this.io = _data['io'];
        }
    }

    static fromJS(data: any): OutputReportDetailsBilling {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportDetailsBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['year'] = this.year;
        data['month'] = this.month;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent;
        data['spmId'] = this.spmId;
        data['spm'] = this.spm;
        data['providerRevenue'] = this.providerRevenue;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['ioId'] = this.ioId;
        data['io'] = this.io;
        return data;
    }

    clone(): OutputReportDetailsBilling {
        const json = this.toJSON();
        let result = new OutputReportDetailsBilling();
        result.init(json);
        return result;
    }
}

export interface IOutputReportDetailsBilling {
    year: number;
    month: number;
    partnerId: number;
    partner: string | undefined;
    salesAgentId: number;
    salesAgent: string | undefined;
    spmId: number;
    spm: string | undefined;
    providerRevenue: number;
    providerId: number;
    provider: string | undefined;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    ioId: number;
    io: string | undefined;
}

export class OutputReportExecSummPartnerBilling implements IOutputReportExecSummPartnerBilling {
    providerId: number;
    provider: string | undefined;
    providerRevenue: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummPartnerBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            if (Array.isArray(_data['providerRevenue'])) {
                this.providerRevenue = [] as any;
                for (let item of _data['providerRevenue']) this.providerRevenue.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummPartnerBilling {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummPartnerBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        if (Array.isArray(this.providerRevenue)) {
            data['providerRevenue'] = [];
            for (let item of this.providerRevenue) data['providerRevenue'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummPartnerBilling {
        const json = this.toJSON();
        let result = new OutputReportExecSummPartnerBilling();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummPartnerBilling {
    providerId: number;
    provider: string | undefined;
    providerRevenue: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportExecSummPartnerCommissions implements IOutputReportExecSummPartnerCommissions {
    providerId: number;
    provider: string | undefined;
    salesAgentCommissions: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummPartnerCommissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            if (Array.isArray(_data['salesAgentCommissions'])) {
                this.salesAgentCommissions = [] as any;
                for (let item of _data['salesAgentCommissions']) this.salesAgentCommissions.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummPartnerCommissions {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummPartnerCommissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        if (Array.isArray(this.salesAgentCommissions)) {
            data['salesAgentCommissions'] = [];
            for (let item of this.salesAgentCommissions) data['salesAgentCommissions'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummPartnerCommissions {
        const json = this.toJSON();
        let result = new OutputReportExecSummPartnerCommissions();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummPartnerCommissions {
    providerId: number;
    provider: string | undefined;
    salesAgentCommissions: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportExecSummProviderBilling implements IOutputReportExecSummProviderBilling {
    partnerId: number;
    partner: string | undefined;
    providerRevenue: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummProviderBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            if (Array.isArray(_data['providerRevenue'])) {
                this.providerRevenue = [] as any;
                for (let item of _data['providerRevenue']) this.providerRevenue.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummProviderBilling {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummProviderBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        if (Array.isArray(this.providerRevenue)) {
            data['providerRevenue'] = [];
            for (let item of this.providerRevenue) data['providerRevenue'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummProviderBilling {
        const json = this.toJSON();
        let result = new OutputReportExecSummProviderBilling();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummProviderBilling {
    partnerId: number;
    partner: string | undefined;
    providerRevenue: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportExecSummProviderCommissions implements IOutputReportExecSummProviderCommissions {
    partnerId: number;
    partner: string | undefined;
    salesAgentCommissions: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummProviderCommissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            if (Array.isArray(_data['salesAgentCommissions'])) {
                this.salesAgentCommissions = [] as any;
                for (let item of _data['salesAgentCommissions']) this.salesAgentCommissions.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummProviderCommissions {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummProviderCommissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        if (Array.isArray(this.salesAgentCommissions)) {
            data['salesAgentCommissions'] = [];
            for (let item of this.salesAgentCommissions) data['salesAgentCommissions'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummProviderCommissions {
        const json = this.toJSON();
        let result = new OutputReportExecSummProviderCommissions();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummProviderCommissions {
    partnerId: number;
    partner: string | undefined;
    salesAgentCommissions: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportTrendingBilling implements IOutputReportTrendingBilling {
    searchType: string | undefined;
    billing: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportTrendingBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data['searchType'];
            if (Array.isArray(_data['billing'])) {
                this.billing = [] as any;
                for (let item of _data['billing']) this.billing.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportTrendingBilling {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportTrendingBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['searchType'] = this.searchType;
        if (Array.isArray(this.billing)) {
            data['billing'] = [];
            for (let item of this.billing) data['billing'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportTrendingBilling {
        const json = this.toJSON();
        let result = new OutputReportTrendingBilling();
        result.init(json);
        return result;
    }
}

export interface IOutputReportTrendingBilling {
    searchType: string | undefined;
    billing: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputRevenueTeamReport implements IOutputRevenueTeamReport {
    orderNumber: string | undefined;
    orderStatus: string | undefined;
    orderCanceled: string | undefined;
    orderReceived: string | undefined;
    orderCompleted: string | undefined;
    contractPeriod: number;
    customerProvider: string | undefined;
    merchantAdvisor: string | undefined;
    endCustomer: string | undefined;
    product: string | undefined;
    investGroup: string | undefined;
    orderAmount: number;

    constructor(data?: IOutputRevenueTeamReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data['orderNumber'];
            this.orderStatus = _data['orderStatus'];
            this.orderCanceled = _data['orderCanceled'];
            this.orderReceived = _data['orderReceived'];
            this.orderCompleted = _data['orderCompleted'];
            this.contractPeriod = _data['contractPeriod'];
            this.customerProvider = _data['customerProvider'];
            this.merchantAdvisor = _data['merchantAdvisor'];
            this.endCustomer = _data['endCustomer'];
            this.product = _data['product'];
            this.investGroup = _data['investGroup'];
            this.orderAmount = _data['orderAmount'];
        }
    }

    static fromJS(data: any): OutputRevenueTeamReport {
        data = typeof data === 'object' ? data : {};
        let result = new OutputRevenueTeamReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderNumber'] = this.orderNumber;
        data['orderStatus'] = this.orderStatus;
        data['orderCanceled'] = this.orderCanceled;
        data['orderReceived'] = this.orderReceived;
        data['orderCompleted'] = this.orderCompleted;
        data['contractPeriod'] = this.contractPeriod;
        data['customerProvider'] = this.customerProvider;
        data['merchantAdvisor'] = this.merchantAdvisor;
        data['endCustomer'] = this.endCustomer;
        data['product'] = this.product;
        data['investGroup'] = this.investGroup;
        data['orderAmount'] = this.orderAmount;
        return data;
    }

    clone(): OutputRevenueTeamReport {
        const json = this.toJSON();
        let result = new OutputRevenueTeamReport();
        result.init(json);
        return result;
    }
}

export interface IOutputRevenueTeamReport {
    orderNumber: string | undefined;
    orderStatus: string | undefined;
    orderCanceled: string | undefined;
    orderReceived: string | undefined;
    orderCompleted: string | undefined;
    contractPeriod: number;
    customerProvider: string | undefined;
    merchantAdvisor: string | undefined;
    endCustomer: string | undefined;
    product: string | undefined;
    investGroup: string | undefined;
    orderAmount: number;
}

export class PagedCommissionCalendarDto implements IPagedCommissionCalendarDto {
    areAllLocked: boolean;
    areAllClosed: boolean;
    total: number;
    totalCount: number;
    items: CommissionCalendarDto[] | undefined;

    constructor(data?: IPagedCommissionCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areAllLocked = _data['areAllLocked'];
            this.areAllClosed = _data['areAllClosed'];
            this.total = _data['total'];
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CommissionCalendarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedCommissionCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedCommissionCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['areAllLocked'] = this.areAllLocked;
        data['areAllClosed'] = this.areAllClosed;
        data['total'] = this.total;
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedCommissionCalendarDto {
        const json = this.toJSON();
        let result = new PagedCommissionCalendarDto();
        result.init(json);
        return result;
    }
}

export interface IPagedCommissionCalendarDto {
    areAllLocked: boolean;
    areAllClosed: boolean;
    total: number;
    totalCount: number;
    items: CommissionCalendarDto[] | undefined;
}

export class PartnerCommissionSummaryDto implements IPartnerCommissionSummaryDto {
    partnerId: number;
    partnerName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    previousMonthTotal: number;
    currentMonthTotal: number;

    constructor(data?: IPartnerCommissionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.previousMonthTotal = _data['previousMonthTotal'];
            this.currentMonthTotal = _data['currentMonthTotal'];
        }
    }

    static fromJS(data: any): PartnerCommissionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCommissionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['previousMonthTotal'] = this.previousMonthTotal;
        data['currentMonthTotal'] = this.currentMonthTotal;
        return data;
    }

    clone(): PartnerCommissionSummaryDto {
        const json = this.toJSON();
        let result = new PartnerCommissionSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerCommissionSummaryDto {
    partnerId: number;
    partnerName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    previousMonthTotal: number;
    currentMonthTotal: number;
}

export class PartnerFirstCommissionOutput implements IPartnerFirstCommissionOutput {
    partner: string | undefined;
    masterAgent: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    firstCommissionDate: moment.Moment;
    firstCheckAmount: number;
    directDeposit: string | undefined;

    constructor(data?: IPartnerFirstCommissionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data['partner'];
            this.masterAgent = _data['masterAgent'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.firstCommissionDate = _data['firstCommissionDate'] ? moment(_data['firstCommissionDate'].toString()) : <any>undefined;
            this.firstCheckAmount = _data['firstCheckAmount'];
            this.directDeposit = _data['directDeposit'];
        }
    }

    static fromJS(data: any): PartnerFirstCommissionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerFirstCommissionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partner'] = this.partner;
        data['masterAgent'] = this.masterAgent;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['firstCommissionDate'] = this.firstCommissionDate ? this.firstCommissionDate.toISOString() : <any>undefined;
        data['firstCheckAmount'] = this.firstCheckAmount;
        data['directDeposit'] = this.directDeposit;
        return data;
    }

    clone(): PartnerFirstCommissionOutput {
        const json = this.toJSON();
        let result = new PartnerFirstCommissionOutput();
        result.init(json);
        return result;
    }
}

export interface IPartnerFirstCommissionOutput {
    partner: string | undefined;
    masterAgent: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    firstCommissionDate: moment.Moment;
    firstCheckAmount: number;
    directDeposit: string | undefined;
}

export class ProviderTemplateEditDto implements IProviderTemplateEditDto {
    tenantId: number | undefined;
    masterAgencyId: number;
    providerId: number;
    provider: ProviderEditDto;
    name: string;
    isDisconnect: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    id: number;

    constructor(data?: IProviderTemplateEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.name = _data['name'];
            this.isDisconnect = _data['isDisconnect'];
            this.startingDate = _data['startingDate'] ? moment(_data['startingDate'].toString()) : <any>undefined;
            this.dayOfMonth = _data['dayOfMonth'];
            this.monthlyRecurrence = _data['monthlyRecurrence'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderTemplateEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderTemplateEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['masterAgencyId'] = this.masterAgencyId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['isDisconnect'] = this.isDisconnect;
        data['startingDate'] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data['dayOfMonth'] = this.dayOfMonth;
        data['monthlyRecurrence'] = this.monthlyRecurrence;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderTemplateEditDto {
        const json = this.toJSON();
        let result = new ProviderTemplateEditDto();
        result.init(json);
        return result;
    }
}

export interface IProviderTemplateEditDto {
    tenantId: number | undefined;
    masterAgencyId: number;
    providerId: number;
    provider: ProviderEditDto;
    name: string;
    isDisconnect: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    id: number;
}

export class ProviderTemplateListDto implements IProviderTemplateListDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    masterAgencyId: number;
    masterAgency: MasterAgencyListDto;
    name: string | undefined;
    isActive: boolean;
    isDisconnect: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IProviderTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.masterAgencyId = _data['masterAgencyId'];
            this.masterAgency = _data['masterAgency'] ? MasterAgencyListDto.fromJS(_data['masterAgency']) : <any>undefined;
            this.name = _data['name'];
            this.isActive = _data['isActive'];
            this.isDisconnect = _data['isDisconnect'];
            this.startingDate = _data['startingDate'] ? moment(_data['startingDate'].toString()) : <any>undefined;
            this.dayOfMonth = _data['dayOfMonth'];
            this.monthlyRecurrence = _data['monthlyRecurrence'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ProviderTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['masterAgencyId'] = this.masterAgencyId;
        data['masterAgency'] = this.masterAgency ? this.masterAgency.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['isActive'] = this.isActive;
        data['isDisconnect'] = this.isDisconnect;
        data['startingDate'] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data['dayOfMonth'] = this.dayOfMonth;
        data['monthlyRecurrence'] = this.monthlyRecurrence;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ProviderTemplateListDto {
        const json = this.toJSON();
        let result = new ProviderTemplateListDto();
        result.init(json);
        return result;
    }
}

export interface IProviderTemplateListDto {
    tenantId: number | undefined;
    providerId: number;
    provider: ProviderEditDto;
    masterAgencyId: number;
    masterAgency: MasterAgencyListDto;
    name: string | undefined;
    isActive: boolean;
    isDisconnect: boolean;
    startingDate: moment.Moment | undefined;
    dayOfMonth: number | undefined;
    monthlyRecurrence: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ProviderTemplateListDtoPagedResultDto implements IProviderTemplateListDtoPagedResultDto {
    totalCount: number;
    items: ProviderTemplateListDto[] | undefined;

    constructor(data?: IProviderTemplateListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ProviderTemplateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderTemplateListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderTemplateListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderTemplateListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProviderTemplateListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProviderTemplateListDtoPagedResultDto {
    totalCount: number;
    items: ProviderTemplateListDto[] | undefined;
}

export class ReportCommissionDetailBanDto implements IReportCommissionDetailBanDto {
    month: number;
    year: number;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    partnerName: string | undefined;
    providerName: string | undefined;
    partnerAcquisitionName: string | undefined;
    providerRevenue: number;
    salesAgentMRR: number;
    salesAgentNRR: number;
    subAgencyCommission: number;
    margin: number;
    partnerOrderNumber: string | undefined;

    constructor(data?: IReportCommissionDetailBanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data['month'];
            this.year = _data['year'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.billingAccountName = _data['billingAccountName'];
            this.partnerName = _data['partnerName'];
            this.providerName = _data['providerName'];
            this.partnerAcquisitionName = _data['partnerAcquisitionName'];
            this.providerRevenue = _data['providerRevenue'];
            this.salesAgentMRR = _data['salesAgentMRR'];
            this.salesAgentNRR = _data['salesAgentNRR'];
            this.subAgencyCommission = _data['subAgencyCommission'];
            this.margin = _data['margin'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
        }
    }

    static fromJS(data: any): ReportCommissionDetailBanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCommissionDetailBanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['month'] = this.month;
        data['year'] = this.year;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['billingAccountName'] = this.billingAccountName;
        data['partnerName'] = this.partnerName;
        data['providerName'] = this.providerName;
        data['partnerAcquisitionName'] = this.partnerAcquisitionName;
        data['providerRevenue'] = this.providerRevenue;
        data['salesAgentMRR'] = this.salesAgentMRR;
        data['salesAgentNRR'] = this.salesAgentNRR;
        data['subAgencyCommission'] = this.subAgencyCommission;
        data['margin'] = this.margin;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        return data;
    }

    clone(): ReportCommissionDetailBanDto {
        const json = this.toJSON();
        let result = new ReportCommissionDetailBanDto();
        result.init(json);
        return result;
    }
}

export interface IReportCommissionDetailBanDto {
    month: number;
    year: number;
    billingAccountNumber: string | undefined;
    billingAccountName: string | undefined;
    partnerName: string | undefined;
    providerName: string | undefined;
    partnerAcquisitionName: string | undefined;
    providerRevenue: number;
    salesAgentMRR: number;
    salesAgentNRR: number;
    subAgencyCommission: number;
    margin: number;
    partnerOrderNumber: string | undefined;
}

export class ReportCommissionDetailDto implements IReportCommissionDetailDto {
    id: number;
    month: number;
    year: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountName: string | undefined;
    billingAccountNumber: string | undefined;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportName: string | undefined;
    revenueMonthYear: string | undefined;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    reference: string | undefined;
    productName: string | undefined;
    note: string | undefined;
    providerRevenue: number;
    partnerSubAgencyPercent: number;
    partnerSubAgencyCommission: number;
    partnerMargin: number;
    templateName: string | undefined;
    commissionTrackingTypeIds: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    ticketId: number | undefined;
    partnerOrderNumber: string | undefined;
    isAdjustment: boolean;

    constructor(data?: IReportCommissionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.salesAgentName = _data['salesAgentName'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
            this.billingAccountName = _data['billingAccountName'];
            this.billingAccountNumber = _data['billingAccountNumber'];
            this.partnerAcquisitionName = _data['partnerAcquisitionName'];
            this.partnerSubAgencyName = _data['partnerSubAgencyName'];
            this.partnerSalesSupportName = _data['partnerSalesSupportName'];
            this.revenueMonthYear = _data['revenueMonthYear'];
            this.salesAgentNRRCommission = _data['salesAgentNRRCommission'];
            this.salesAgentCommissionPercent = _data['salesAgentCommissionPercent'];
            this.salesAgentCommissionAmount = _data['salesAgentCommissionAmount'];
            this.salesAgentCommissionPercentOfProviderRevenue = _data['salesAgentCommissionPercentOfProviderRevenue'];
            this.reference = _data['reference'];
            this.productName = _data['productName'];
            this.note = _data['note'];
            this.providerRevenue = _data['providerRevenue'];
            this.partnerSubAgencyPercent = _data['partnerSubAgencyPercent'];
            this.partnerSubAgencyCommission = _data['partnerSubAgencyCommission'];
            this.partnerMargin = _data['partnerMargin'];
            this.templateName = _data['templateName'];
            this.commissionTrackingTypeIds = _data['commissionTrackingTypeIds'];
            this.commissionTrackingTypeNames = _data['commissionTrackingTypeNames'];
            this.ticketId = _data['ticketId'];
            this.partnerOrderNumber = _data['partnerOrderNumber'];
            this.isAdjustment = _data['isAdjustment'];
        }
    }

    static fromJS(data: any): ReportCommissionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCommissionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['month'] = this.month;
        data['year'] = this.year;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['salesAgentName'] = this.salesAgentName;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        data['billingAccountName'] = this.billingAccountName;
        data['billingAccountNumber'] = this.billingAccountNumber;
        data['partnerAcquisitionName'] = this.partnerAcquisitionName;
        data['partnerSubAgencyName'] = this.partnerSubAgencyName;
        data['partnerSalesSupportName'] = this.partnerSalesSupportName;
        data['revenueMonthYear'] = this.revenueMonthYear;
        data['salesAgentNRRCommission'] = this.salesAgentNRRCommission;
        data['salesAgentCommissionPercent'] = this.salesAgentCommissionPercent;
        data['salesAgentCommissionAmount'] = this.salesAgentCommissionAmount;
        data['salesAgentCommissionPercentOfProviderRevenue'] = this.salesAgentCommissionPercentOfProviderRevenue;
        data['reference'] = this.reference;
        data['productName'] = this.productName;
        data['note'] = this.note;
        data['providerRevenue'] = this.providerRevenue;
        data['partnerSubAgencyPercent'] = this.partnerSubAgencyPercent;
        data['partnerSubAgencyCommission'] = this.partnerSubAgencyCommission;
        data['partnerMargin'] = this.partnerMargin;
        data['templateName'] = this.templateName;
        data['commissionTrackingTypeIds'] = this.commissionTrackingTypeIds;
        data['commissionTrackingTypeNames'] = this.commissionTrackingTypeNames;
        data['ticketId'] = this.ticketId;
        data['partnerOrderNumber'] = this.partnerOrderNumber;
        data['isAdjustment'] = this.isAdjustment;
        return data;
    }

    clone(): ReportCommissionDetailDto {
        const json = this.toJSON();
        let result = new ReportCommissionDetailDto();
        result.init(json);
        return result;
    }
}

export interface IReportCommissionDetailDto {
    id: number;
    month: number;
    year: number;
    partnerId: number;
    partnerName: string | undefined;
    salesAgentName: string | undefined;
    providerId: number;
    providerName: string | undefined;
    billingAccountName: string | undefined;
    billingAccountNumber: string | undefined;
    partnerAcquisitionName: string | undefined;
    partnerSubAgencyName: string | undefined;
    partnerSalesSupportName: string | undefined;
    revenueMonthYear: string | undefined;
    salesAgentNRRCommission: number;
    salesAgentCommissionPercent: number;
    salesAgentCommissionAmount: number;
    salesAgentCommissionPercentOfProviderRevenue: number;
    reference: string | undefined;
    productName: string | undefined;
    note: string | undefined;
    providerRevenue: number;
    partnerSubAgencyPercent: number;
    partnerSubAgencyCommission: number;
    partnerMargin: number;
    templateName: string | undefined;
    commissionTrackingTypeIds: string | undefined;
    commissionTrackingTypeNames: string | undefined;
    ticketId: number | undefined;
    partnerOrderNumber: string | undefined;
    isAdjustment: boolean;
}

export class ReportPartnerCommissionHistory implements IReportPartnerCommissionHistory {
    date: string | undefined;
    revenue: number;
    commission: number;

    constructor(data?: IReportPartnerCommissionHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'];
            this.revenue = _data['revenue'];
            this.commission = _data['commission'];
        }
    }

    static fromJS(data: any): ReportPartnerCommissionHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPartnerCommissionHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date;
        data['revenue'] = this.revenue;
        data['commission'] = this.commission;
        return data;
    }

    clone(): ReportPartnerCommissionHistory {
        const json = this.toJSON();
        let result = new ReportPartnerCommissionHistory();
        result.init(json);
        return result;
    }
}

export interface IReportPartnerCommissionHistory {
    date: string | undefined;
    revenue: number;
    commission: number;
}

export enum ReportUploaderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ResetCommissionReviewFileInput implements IResetCommissionReviewFileInput {
    providerId: number;
    month: number;
    year: number;
    commissionTemplateId: number;
    masterAgencyId: number;

    constructor(data?: IResetCommissionReviewFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.masterAgencyId = _data['masterAgencyId'];
        }
    }

    static fromJS(data: any): ResetCommissionReviewFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetCommissionReviewFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['masterAgencyId'] = this.masterAgencyId;
        return data;
    }

    clone(): ResetCommissionReviewFileInput {
        const json = this.toJSON();
        let result = new ResetCommissionReviewFileInput();
        result.init(json);
        return result;
    }
}

export interface IResetCommissionReviewFileInput {
    providerId: number;
    month: number;
    year: number;
    commissionTemplateId: number;
    masterAgencyId: number;
}

export enum ScheduleTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SetCommissionReceivableReviewInput implements ISetCommissionReceivableReviewInput {
    lstCommissionReceivableReviewInput: CommissionReceivableReviewInputEditDto[] | undefined;

    constructor(data?: ISetCommissionReceivableReviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['lstCommissionReceivableReviewInput'])) {
                this.lstCommissionReceivableReviewInput = [] as any;
                for (let item of _data['lstCommissionReceivableReviewInput'])
                    this.lstCommissionReceivableReviewInput.push(CommissionReceivableReviewInputEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetCommissionReceivableReviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetCommissionReceivableReviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lstCommissionReceivableReviewInput)) {
            data['lstCommissionReceivableReviewInput'] = [];
            for (let item of this.lstCommissionReceivableReviewInput) data['lstCommissionReceivableReviewInput'].push(item.toJSON());
        }
        return data;
    }

    clone(): SetCommissionReceivableReviewInput {
        const json = this.toJSON();
        let result = new SetCommissionReceivableReviewInput();
        result.init(json);
        return result;
    }
}

export interface ISetCommissionReceivableReviewInput {
    lstCommissionReceivableReviewInput: CommissionReceivableReviewInputEditDto[] | undefined;
}

export class TemplateDetailEditDto implements ITemplateDetailEditDto {
    tenantId: number | undefined;
    commissionTemplateId: number;
    commissionField: string | undefined;
    providerField: string | undefined;
    id: number;

    constructor(data?: ITemplateDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.commissionField = _data['commissionField'];
            this.providerField = _data['providerField'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TemplateDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['commissionField'] = this.commissionField;
        data['providerField'] = this.providerField;
        data['id'] = this.id;
        return data;
    }

    clone(): TemplateDetailEditDto {
        const json = this.toJSON();
        let result = new TemplateDetailEditDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateDetailEditDto {
    tenantId: number | undefined;
    commissionTemplateId: number;
    commissionField: string | undefined;
    providerField: string | undefined;
    id: number;
}

export class Top6CustomersByBillingDashboardOutput implements ITop6CustomersByBillingDashboardOutput {
    customerName: string | undefined;
    billingAmount: number;

    constructor(data?: ITop6CustomersByBillingDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data['customerName'];
            this.billingAmount = _data['billingAmount'];
        }
    }

    static fromJS(data: any): Top6CustomersByBillingDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new Top6CustomersByBillingDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerName'] = this.customerName;
        data['billingAmount'] = this.billingAmount;
        return data;
    }

    clone(): Top6CustomersByBillingDashboardOutput {
        const json = this.toJSON();
        let result = new Top6CustomersByBillingDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ITop6CustomersByBillingDashboardOutput {
    customerName: string | undefined;
    billingAmount: number;
}

export class Top6CustomersByCommissionAmountDashboardOutput implements ITop6CustomersByCommissionAmountDashboardOutput {
    customerName: string | undefined;
    commissionAmount: number;

    constructor(data?: ITop6CustomersByCommissionAmountDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data['customerName'];
            this.commissionAmount = _data['commissionAmount'];
        }
    }

    static fromJS(data: any): Top6CustomersByCommissionAmountDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new Top6CustomersByCommissionAmountDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerName'] = this.customerName;
        data['commissionAmount'] = this.commissionAmount;
        return data;
    }

    clone(): Top6CustomersByCommissionAmountDashboardOutput {
        const json = this.toJSON();
        let result = new Top6CustomersByCommissionAmountDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ITop6CustomersByCommissionAmountDashboardOutput {
    customerName: string | undefined;
    commissionAmount: number;
}

export class Top6ProvidersByBillingDashboardOutput implements ITop6ProvidersByBillingDashboardOutput {
    providerName: string | undefined;
    billingAmount: number;

    constructor(data?: ITop6ProvidersByBillingDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerName = _data['providerName'];
            this.billingAmount = _data['billingAmount'];
        }
    }

    static fromJS(data: any): Top6ProvidersByBillingDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new Top6ProvidersByBillingDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerName'] = this.providerName;
        data['billingAmount'] = this.billingAmount;
        return data;
    }

    clone(): Top6ProvidersByBillingDashboardOutput {
        const json = this.toJSON();
        let result = new Top6ProvidersByBillingDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ITop6ProvidersByBillingDashboardOutput {
    providerName: string | undefined;
    billingAmount: number;
}

export class Top6ProvidersByCommissionDashboardOutput implements ITop6ProvidersByCommissionDashboardOutput {
    providerName: string | undefined;
    commissionAmount: number;

    constructor(data?: ITop6ProvidersByCommissionDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerName = _data['providerName'];
            this.commissionAmount = _data['commissionAmount'];
        }
    }

    static fromJS(data: any): Top6ProvidersByCommissionDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new Top6ProvidersByCommissionDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerName'] = this.providerName;
        data['commissionAmount'] = this.commissionAmount;
        return data;
    }

    clone(): Top6ProvidersByCommissionDashboardOutput {
        const json = this.toJSON();
        let result = new Top6ProvidersByCommissionDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ITop6ProvidersByCommissionDashboardOutput {
    providerName: string | undefined;
    commissionAmount: number;
}

export class UpdateCommissionCalendarInput implements IUpdateCommissionCalendarInput {
    comCalendar: CommissionCalendarEditDto[] | undefined;
    month: number;
    year: number;

    constructor(data?: IUpdateCommissionCalendarInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['comCalendar'])) {
                this.comCalendar = [] as any;
                for (let item of _data['comCalendar']) this.comCalendar.push(CommissionCalendarEditDto.fromJS(item));
            }
            this.month = _data['month'];
            this.year = _data['year'];
        }
    }

    static fromJS(data: any): UpdateCommissionCalendarInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommissionCalendarInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comCalendar)) {
            data['comCalendar'] = [];
            for (let item of this.comCalendar) data['comCalendar'].push(item.toJSON());
        }
        data['month'] = this.month;
        data['year'] = this.year;
        return data;
    }

    clone(): UpdateCommissionCalendarInput {
        const json = this.toJSON();
        let result = new UpdateCommissionCalendarInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCommissionCalendarInput {
    comCalendar: CommissionCalendarEditDto[] | undefined;
    month: number;
    year: number;
}

export class UpdateCommissionOnHoldInput implements IUpdateCommissionOnHoldInput {
    commissionWorkBookId: number;
    salesAgentId: number;
    partnerId: number;

    constructor(data?: IUpdateCommissionOnHoldInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionWorkBookId = _data['commissionWorkBookId'];
            this.salesAgentId = _data['salesAgentId'];
            this.partnerId = _data['partnerId'];
        }
    }

    static fromJS(data: any): UpdateCommissionOnHoldInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommissionOnHoldInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionWorkBookId'] = this.commissionWorkBookId;
        data['salesAgentId'] = this.salesAgentId;
        data['partnerId'] = this.partnerId;
        return data;
    }

    clone(): UpdateCommissionOnHoldInput {
        const json = this.toJSON();
        let result = new UpdateCommissionOnHoldInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCommissionOnHoldInput {
    commissionWorkBookId: number;
    salesAgentId: number;
    partnerId: number;
}

export class UpdateCommissionReviewFileInput implements IUpdateCommissionReviewFileInput {
    fileName: string;
    providerId: number;
    month: number;
    year: number;
    commissionTemplateId: number;
    masterAgencyId: number;

    constructor(data?: IUpdateCommissionReviewFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.providerId = _data['providerId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.commissionTemplateId = _data['commissionTemplateId'];
            this.masterAgencyId = _data['masterAgencyId'];
        }
    }

    static fromJS(data: any): UpdateCommissionReviewFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommissionReviewFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['providerId'] = this.providerId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['commissionTemplateId'] = this.commissionTemplateId;
        data['masterAgencyId'] = this.masterAgencyId;
        return data;
    }

    clone(): UpdateCommissionReviewFileInput {
        const json = this.toJSON();
        let result = new UpdateCommissionReviewFileInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCommissionReviewFileInput {
    fileName: string;
    providerId: number;
    month: number;
    year: number;
    commissionTemplateId: number;
    masterAgencyId: number;
}

export class UploadCommissionFileInput implements IUploadCommissionFileInput {
    fileName: string;

    constructor(data?: IUploadCommissionFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
        }
    }

    static fromJS(data: any): UploadCommissionFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCommissionFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        return data;
    }

    clone(): UploadCommissionFileInput {
        const json = this.toJSON();
        let result = new UploadCommissionFileInput();
        result.init(json);
        return result;
    }
}

export interface IUploadCommissionFileInput {
    fileName: string;
}

export class UploadProviderFileInput implements IUploadProviderFileInput {
    userIdentifier: UserIdentifier;
    providerId: number;
    month: number;
    year: number;
    masterAgencyId: number;
    templateId: number;

    constructor(data?: IUploadProviderFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data['userIdentifier'] ? UserIdentifier.fromJS(_data['userIdentifier']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.masterAgencyId = _data['masterAgencyId'];
            this.templateId = _data['templateId'];
        }
    }

    static fromJS(data: any): UploadProviderFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProviderFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userIdentifier'] = this.userIdentifier ? this.userIdentifier.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['month'] = this.month;
        data['year'] = this.year;
        data['masterAgencyId'] = this.masterAgencyId;
        data['templateId'] = this.templateId;
        return data;
    }

    clone(): UploadProviderFileInput {
        const json = this.toJSON();
        let result = new UploadProviderFileInput();
        result.init(json);
        return result;
    }
}

export interface IUploadProviderFileInput {
    userIdentifier: UserIdentifier;
    providerId: number;
    month: number;
    year: number;
    masterAgencyId: number;
    templateId: number;
}

export class UploadProviderTemplatFileInput implements IUploadProviderTemplatFileInput {
    fileName: string;

    constructor(data?: IUploadProviderTemplatFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
        }
    }

    static fromJS(data: any): UploadProviderTemplatFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProviderTemplatFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        return data;
    }

    clone(): UploadProviderTemplatFileInput {
        const json = this.toJSON();
        let result = new UploadProviderTemplatFileInput();
        result.init(json);
        return result;
    }
}

export interface IUploadProviderTemplatFileInput {
    fileName: string;
}

export class UploadProviderTemplatFileOutput implements IUploadProviderTemplatFileOutput {
    providerFields: string[] | undefined;

    constructor(data?: IUploadProviderTemplatFileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['providerFields'])) {
                this.providerFields = [] as any;
                for (let item of _data['providerFields']) this.providerFields.push(item);
            }
        }
    }

    static fromJS(data: any): UploadProviderTemplatFileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProviderTemplatFileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerFields)) {
            data['providerFields'] = [];
            for (let item of this.providerFields) data['providerFields'].push(item);
        }
        return data;
    }

    clone(): UploadProviderTemplatFileOutput {
        const json = this.toJSON();
        let result = new UploadProviderTemplatFileOutput();
        result.init(json);
        return result;
    }
}

export interface IUploadProviderTemplatFileOutput {
    providerFields: string[] | undefined;
}

export class UploadStatusOutput implements IUploadStatusOutput {
    providerId: number;
    provider: string | undefined;
    month: number;
    year: number;
    numberOfRecords: number;
    providerRevenue: number;
    microcorpCommissionAmount: number;
    microcorpNonRecurringCommissionAmount: number;
    salesAgentNrrCommission: number;
    agentCommissionAmount: number;
    grossMargin: number;

    constructor(data?: IUploadStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            this.month = _data['month'];
            this.year = _data['year'];
            this.numberOfRecords = _data['numberOfRecords'];
            this.providerRevenue = _data['providerRevenue'];
            this.microcorpCommissionAmount = _data['microcorpCommissionAmount'];
            this.microcorpNonRecurringCommissionAmount = _data['microcorpNonRecurringCommissionAmount'];
            this.salesAgentNrrCommission = _data['salesAgentNrrCommission'];
            this.agentCommissionAmount = _data['agentCommissionAmount'];
            this.grossMargin = _data['grossMargin'];
        }
    }

    static fromJS(data: any): UploadStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        data['month'] = this.month;
        data['year'] = this.year;
        data['numberOfRecords'] = this.numberOfRecords;
        data['providerRevenue'] = this.providerRevenue;
        data['microcorpCommissionAmount'] = this.microcorpCommissionAmount;
        data['microcorpNonRecurringCommissionAmount'] = this.microcorpNonRecurringCommissionAmount;
        data['salesAgentNrrCommission'] = this.salesAgentNrrCommission;
        data['agentCommissionAmount'] = this.agentCommissionAmount;
        data['grossMargin'] = this.grossMargin;
        return data;
    }

    clone(): UploadStatusOutput {
        const json = this.toJSON();
        let result = new UploadStatusOutput();
        result.init(json);
        return result;
    }
}

export interface IUploadStatusOutput {
    providerId: number;
    provider: string | undefined;
    month: number;
    year: number;
    numberOfRecords: number;
    providerRevenue: number;
    microcorpCommissionAmount: number;
    microcorpNonRecurringCommissionAmount: number;
    salesAgentNrrCommission: number;
    agentCommissionAmount: number;
    grossMargin: number;
}

export enum UploaderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UserIdentifier implements IUserIdentifier {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IUserIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): UserIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        return data;
    }

    clone(): UserIdentifier {
        const json = this.toJSON();
        let result = new UserIdentifier();
        result.init(json);
        return result;
    }
}

export interface IUserIdentifier {
    tenantId: number | undefined;
    userId: number;
}
